import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {EventPreviewService} from 'src/app/services/event-preview.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';

@Component({
  selector: 'app-archive49',
  templateUrl: './archive49.component.html',
  styleUrls: ['./archive49.component.scss']
})
export class Archive49Component implements OnInit {

  public dataPreviewForDate_1: any;
  public dataPreviewForDate_2: any;

  public dataPreviewForLocations: any;

  public selectedTab;

  constructor (
    public _sanitizer: DomSanitizer,
    private _spinnerService: SpinnerService,
    public _eventPreviewService: EventPreviewService,

  ) {

    this.preview()
  }

  ngOnInit () {
    this.toggleCard('0')
  }

  toggleCard (idx) {
    this.selectedTab = idx
  }

  preview () {
    const waiting = this._spinnerService.show();

        const ret = this.getCongress49Data()

        const previewForDates = this._eventPreviewService.makeHTMLDataForDates(ret.data)

        this.dataPreviewForLocations = this._eventPreviewService.makeHTMLDataForLocatios(ret.data)

        this.dataPreviewForDate_1 = this._sanitizer.bypassSecurityTrustHtml(previewForDates.html_1)
        this.dataPreviewForDate_2 = this._sanitizer.bypassSecurityTrustHtml(previewForDates.html_2)

        waiting.close()
  }

  getCongress49Data() {
    return {
      "data": {
        "id": "qBicALVh9y4CdiTXYGrm",
        "name": "49º Congresso da SBCCV • 2023",
        "text": "",
        "materials": [],
        "location": "Centro Cultural e de Exposições Ruth Cardoso",
        "limit": null,
        "agenda": [],
        "days": [
          {
            "text": "",
            "materials": [],
            "id": "DBXFrf5DkWpT2TvjxMNx",
            "event_id": "qBicALVh9y4CdiTXYGrm",
            "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
            "name": "Segundo Dia",
            "agenda": [],
            "activities": [
              {
                "id": "1FllR9BZUn2mfB45fVvV",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "MESA REDONDA III - AORTA ",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZnzxDdrZVoNZPLuaxGTG",
                    "activity_name": "MESA REDONDA III - AORTA ",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Luciano Cabral Albuquerque ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "xOE7su8C93MoAlR0hIgK",
                    "activity_name": "MESA REDONDA III - AORTA ",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Alexandre Ciappina Hueb ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "TvgA5XSRv0tIu3TOSOcK",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Reimplante valvar aórtico (Cirurgia de David). Indicação e resultados",
                    "text": "",
                    "startTime": "08:50",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "9k0EGRTP67Xcz878MBZa",
                        "activity_name": "MESA REDONDA III - AORTA ",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Ricardo Ribeiro Dias ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1FllR9BZUn2mfB45fVvV",
                        "topic_name": "Reimplante valvar aórtico (Cirurgia de David). Indicação e resultados",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "TvgA5XSRv0tIu3TOSOcK",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "i1IeXzBZEhSTfcPAJmiG",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "10:10",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "ijOSKn424HdWG6t6e6Id",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Dissecção aguda aórtica tipo A em paciente com lesão neurológica. Tratamento cirúrgico imediato ou expectante?",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "9bpCBQ85pG4g5h1I9TtZ",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA III - AORTA ",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Henrique Murad ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1FllR9BZUn2mfB45fVvV",
                        "topic_name": "Dissecção aguda aórtica tipo A em paciente com lesão neurológica. Tratamento cirúrgico imediato ou expectante?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ijOSKn424HdWG6t6e6Id",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qnanf3bjKdSBi4yxF4BM",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Quais os fatores determinantes para o reparo total do arco aórtico na dissecção aguda do Tipo A?",
                    "text": "",
                    "startTime": "09:10",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "mhJB0SuYtcugC3F5N1MT",
                        "activity_name": "MESA REDONDA III - AORTA ",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Paulo Roberto Lunardi Prates ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:10",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1FllR9BZUn2mfB45fVvV",
                        "topic_name": "Quais os fatores determinantes para o reparo total do arco aórtico na dissecção aguda do Tipo A?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qnanf3bjKdSBi4yxF4BM",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "r9VmJijNSS95vxDf2QeZ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Tratamento endovascular do arco aórtico",
                    "text": "",
                    "startTime": "09:50",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "JyS5Mj4rUgRaqWTRMXRx",
                        "activity_name": "MESA REDONDA III - AORTA ",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Cledicyon Eloy da Costa",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1FllR9BZUn2mfB45fVvV",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "r9VmJijNSS95vxDf2QeZ",
                        "topic_name": "Tratamento endovascular do arco aórtico",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "v9LktvL950nHmw5Av5E9",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1FllR9BZUn2mfB45fVvV",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Válvula aórtica bicúspide e aneurisma de aorta. Quando intervir no aneurisma?",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "3PGBHb0C3UO8TXp9gDM2",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA III - AORTA ",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Jocerlano Santos de Sousa ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1FllR9BZUn2mfB45fVvV",
                        "topic_name": "Válvula aórtica bicúspide e aneurisma de aorta. Quando intervir no aneurisma?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "v9LktvL950nHmw5Av5E9",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "1oonMpM38bDigI6402tm",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "16:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "SV8aQrmdso9sBTBL6zU0",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Alfredo Inácio Fiorelli ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "Xywh7J89TS2CTgS4KLz7",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "16:15",
                    "member_name": "Antonio Amauri Groppo ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "6gjbMKVvas116DLkbiqD",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Aneurisma de aorta ascendente. Estado da Arte",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "9k0EGRTP67Xcz878MBZa",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Ricardo Ribeiro Dias ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1oonMpM38bDigI6402tm",
                        "topic_name": "Aneurisma de aorta ascendente. Estado da Arte",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "6gjbMKVvas116DLkbiqD",
                        "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "C5u788NhpSEuVnNPDMFw",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Critério de indicações, contraindicações e fatores de risco na TAVI",
                    "text": "",
                    "startTime": "16:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "AtXcVcGzQRhRm88BYtTT",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Felipe Reale Cividanes ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1oonMpM38bDigI6402tm",
                        "topic_name": "Critério de indicações, contraindicações e fatores de risco na TAVI",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "C5u788NhpSEuVnNPDMFw",
                        "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "CDWL6N6JIwDrJXYLDY9J",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TAVI - Desenvolvimento e onde estamos",
                    "text": "",
                    "startTime": "16:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "5yrGDXcl3mMyHZSJbuow",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "José Honório de Almeida Palma Fonseca",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1oonMpM38bDigI6402tm",
                        "topic_name": "TAVI - Desenvolvimento e onde estamos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "CDWL6N6JIwDrJXYLDY9J",
                        "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "aD3dEqbLdCvf311X0rCf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "25",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "ufCVTcxF6PNWTr0vUrAp",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "1oonMpM38bDigI6402tm",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Revascularização do miocárdio na presença de disfunção ventricular",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "GkPljbxZKTpR5XQl9nze",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Ricardo de Carvalho Lima ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Revascularização do miocárdio na presença de disfunção ventricular",
                        "activity_id": "1oonMpM38bDigI6402tm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ufCVTcxF6PNWTr0vUrAp",
                        "activity_name": " DECARDIO - MESA REDONDA II - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "9TwwNqCbEn9vzWrRyDAq",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZlzhIrAEmqcQschHp0Lf",
                    "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Fabiana Michelle Feitosa de Oliveira",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                    "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Pedro Rafael Salerno ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "FTBJjkBPdirCokaNC3cd",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Variações técnicas no transplante cardíaco ortotópico",
                    "text": "",
                    "startTime": "11:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "vXfovm1wt1yDTbcBo0A6",
                        "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Marcello Laneza Felício ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                        "topic_name": "Variações técnicas no transplante cardíaco ortotópico",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "FTBJjkBPdirCokaNC3cd",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "Ism52efvwSr4qFZ9H0jS",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Suporte Circulatório - Novas perspectivas",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "L14lyaA2guegwmc8salH",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Luiz Fernando Kubrusly ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Ism52efvwSr4qFZ9H0jS",
                        "topic_name": "Suporte Circulatório - Novas perspectivas",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "JQPdTi6tBwogTddv3r9l",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "12:20",
                    "duration": "25",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "Ox14KZXZVevkTWzu2qwQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Transplante heterotópico em paciente com hiperresistência pulmonar",
                    "text": "",
                    "startTime": "11:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "TNegaNCo8I6SdabN45Gc",
                        "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Samuel Padovani Steffen ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                        "topic_name": "Transplante heterotópico em paciente com hiperresistência pulmonar",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Ox14KZXZVevkTWzu2qwQ",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "W9nQk9IyBOnXidhZBfrV",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Indicação de retransplante cardíaco",
                    "text": "",
                    "startTime": "12:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "0qhPHbRIIKFp5Na5NXvN",
                        "activity_name": "MESA REDONDA VIII - ASSISTÊNCIA CIRCULATÓRIA VENTRICULAR E TRANSPLANTE CARDÍACO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Noedir Antonio Groppo Stolf ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "12:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "9TwwNqCbEn9vzWrRyDAq",
                        "topic_name": "Indicação de retransplante cardíaco",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "W9nQk9IyBOnXidhZBfrV",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "C59FE1DPONAwQ0lPTnv8",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "RYDKllEwxDZR8rGlgksq",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Fernando Antonio Fantini ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "FjybEQe6bu0giHrR1tNN",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Fernando Ribeiro Moraes Neto ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "0CBNA5L2neeVanfdvBS4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "K4aEH6CNbDI9nMTe8WL4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Stent no canal arterial como procedimento de escolha?",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "DbmQfUmMzD8XPUNH3IJ8",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Juliana Neves",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "C59FE1DPONAwQ0lPTnv8",
                        "topic_name": "Stent no canal arterial como procedimento de escolha?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "K4aEH6CNbDI9nMTe8WL4",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "OU6S0bVBVa2dqsbDlVWu",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Shunt sistêmico pulmonar I - Como eu faço, com ou sem CEC? Esternotomia ou toracotomia?",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "KGboPJaP8ub7mjron2Qe",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Fernando Antoniali ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "C59FE1DPONAwQ0lPTnv8",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "OU6S0bVBVa2dqsbDlVWu",
                        "topic_name": "Shunt sistêmico pulmonar I - Como eu faço, com ou sem CEC? Esternotomia ou toracotomia?",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qZL5sMnNCxA9JzgbOzfJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "C59FE1DPONAwQ0lPTnv8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Shunt sistêmico pulmonar II - Ligar ou não o canal arterial? Coarctação pulmonar - como abordar?",
                    "text": "",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "IhkEw3DWE01hzwAJyxuR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Bruno da Costa Rocha ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "C59FE1DPONAwQ0lPTnv8",
                        "topic_name": "Shunt sistêmico pulmonar II - Ligar ou não o canal arterial? Coarctação pulmonar - como abordar?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qZL5sMnNCxA9JzgbOzfJ",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - MANEJO DE NEONATOS COM FISIOLOGIA UNIVENTRICULAR E HIPOFLUXO PULMONAR",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "EG52Q0LUPTSV2kVlPLd8",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "Mcvc4sHHB11aTzQdlAIP",
                    "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Fernando Antonio Roquette Reis Filho ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 2"
                  },
                  {
                    "member_id": "Z8uiF2pLISUKj38hBtiT",
                    "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Valquiria Pelisser Campagnucci ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 2"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "3XyDNMXlccOO6gQJOWxk",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "No Cardiointensivismo",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "pw7FmMZMBTtsbcRfAVBk",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "José Teles de Mendonça ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                        "topic_name": "No Cardiointensivismo",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "3XyDNMXlccOO6gQJOWxk",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "EeY0g9tRx0xtISxtUEG3",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": " Avanços nas tecnologias de monitorização eletrocardiográfica prolongada",
                    "text": "",
                    "startTime": "08:50",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "FEbCktFHlpcpOeucunjk",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Fátima Dumas Cintra",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "EeY0g9tRx0xtISxtUEG3",
                        "topic_name": " Avanços nas tecnologias de monitorização eletrocardiográfica prolongada",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "RdnvWNdYQtdaLV4lV3xm",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na elaboração de Diretrizes em conjunto com especialidades afins",
                    "text": "",
                    "startTime": "09:10",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "zUJF3rGEzCCujnzfeA9P",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Walter José Gomes ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:10",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                        "topic_name": "Na elaboração de Diretrizes em conjunto com especialidades afins",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "RdnvWNdYQtdaLV4lV3xm",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "h5qKJ1FhWur9uux7kk4t",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na implementação da TAVI no SUS",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "487mQwdaZGJfbJ8NbJ9n",
                        "activity_name": "MESA REDONDA V - ATUAÇÕES IMPORTANTES DO CIRURGIÃO CARDIOVASCULAR",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "João Carlos Ferreira Leal ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Na implementação da TAVI no SUS",
                        "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "h5qKJ1FhWur9uux7kk4t",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pJww2KAXDlgapEyDmsC5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "EG52Q0LUPTSV2kVlPLd8",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "09:50",
                    "duration": "40",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "G2YA7Kk3iZ6WLAiuwd0U",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "CERIMÔNIA DE ENCERRAMENTO DO CONGRESSO, PREMIAÇÃO DOS TEMAS LIVRES DA SBCCV, LIGA ACADÊMICA E DEMAIS HOMENAGENS E ABERTURA DOS FÓRUNS DOS DEPARTAMENTOS",
                "text": "<p><strong>Dinâmica:</strong> O Mestre de cerimônias abrirá a Cerimônia, devendo seguir roteiro próprio.&nbsp;</p><p>Deverá haver assistente de palco e assistente de plateia.</p><p>Fotógrafo deverá estar presente para as fotos</p>",
                "startTime": "12:45",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "19uVekTYDoM2DHnIftBY",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "G2YA7Kk3iZ6WLAiuwd0U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "CERIMÔNIA DE ENCERRAMENTO DO CONGRESSO, PREMIAÇÃO DOS TEMAS LIVRES DA SBCCV, LIGA ACADÊMICA E DEMAIS HOMENAGENS E ABERTURA DOS FÓRUNS DOS DEPARTAMENTOS",
                    "text": "",
                    "startTime": "12:45",
                    "duration": "75",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "GirWxbK8WFKPxE9GyXxP",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "14:05",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "n5ncSJi4i631o9bykgk6",
                    "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:05",
                    "member_name": "Luiz Paulo Rangel Gomes da Silva ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Debatedor(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "8xaAN7yNUDDOVNkWcgFG",
                    "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:05",
                    "member_name": "André Raimundo Franca Guimarães ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "6QisZ6kM0eraJV2egjJa",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Moderador(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "nreL4X3kvmJVZ6Gs05wq",
                    "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:05",
                    "member_name": "Ricardo Estéfano Germano ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Debatedor(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "WwQ0apN35rijenFwGt9i",
                    "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:05",
                    "member_name": "Victor Bauer Júnior ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Presidente",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "n3EoDSuxQZNObutTSI6s",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "1lES4hGNDzrpduu3XOHx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "14:50",
                    "duration": "10",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "3gqpkhJ7zQBE7Y1euU6p",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Principais aspectos fisiopatológicos envolvidos na remodelação do ventrículo esquerdo",
                    "text": "",
                    "startTime": "14:05",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ggH8mj2948XenAMCPLXk",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "Elmiro Santos Resende",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Principais aspectos fisiopatológicos envolvidos na remodelação do ventrículo esquerdo",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "3gqpkhJ7zQBE7Y1euU6p",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "FRc1ZbkZmxSdL9CHxuPU",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Resposta inflamatória no pós-operatório de cirurgia com e sem CEC",
                    "text": "",
                    "startTime": "15:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "xOE7su8C93MoAlR0hIgK",
                        "topic_duration": "15",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "Alexandre Ciappina Hueb ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Resposta inflamatória no pós-operatório de cirurgia com e sem CEC",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "FRc1ZbkZmxSdL9CHxuPU",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "HD5v3DLSSKpxMZo8SdKs",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Cirurgia de Tirone David - Atualização",
                    "text": "",
                    "startTime": "15:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "nogq5P5D7b3aSVHF6goW",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "Milton de Miranda Santoro ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "topic_name": "Cirurgia de Tirone David - Atualização",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "HD5v3DLSSKpxMZo8SdKs",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "KAGDIwskPIfjDnRQofgk",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:45",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "Z5Tp9pPOBMmOxXXj7RsV",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Modelo experimental de infarto do miocárdio induzido por isoproterenol em ratos",
                    "text": "",
                    "startTime": "14:20",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7qi2vEYdO3teszgHsWwG",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "Heraldo Guedis Lobo Filho ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "topic_name": "Modelo experimental de infarto do miocárdio induzido por isoproterenol em ratos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Z5Tp9pPOBMmOxXXj7RsV",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "baXiWO2oq8ILcKWiMm9r",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Cirurgia de revascularização miocárdica - Estado da Arte",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "GkPljbxZKTpR5XQl9nze",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "Ricardo de Carvalho Lima ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Cirurgia de revascularização miocárdica - Estado da Arte",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "baXiWO2oq8ILcKWiMm9r",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "jIdIRnSZ8VyLlnrTyJhj",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GirWxbK8WFKPxE9GyXxP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Avaliação funcional e exercício na evolução tardia da Operação de Fontan",
                    "text": "",
                    "startTime": "14:35",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "DKvjDU83qAAc3Sm3Mp0t",
                        "activity_name": "DEPEX - MESA REDONDA - ATUALIZAÇÕES EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:05",
                        "member_name": "A DEFINIR",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GirWxbK8WFKPxE9GyXxP",
                        "topic_name": "Avaliação funcional e exercício na evolução tardia da Operação de Fontan",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jIdIRnSZ8VyLlnrTyJhj"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "GxgkmkWhlSGypyIvmZFq",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "16:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "xOE7su8C93MoAlR0hIgK",
                    "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Alexandre Ciappina Hueb ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Debatedor(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "nogq5P5D7b3aSVHF6goW",
                    "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Milton de Miranda Santoro ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Debatedor(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "7qi2vEYdO3teszgHsWwG",
                    "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "activity_startTime": "16:15",
                    "member_name": "Heraldo Guedis Lobo Filho ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "6QisZ6kM0eraJV2egjJa",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Moderador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "ggH8mj2948XenAMCPLXk",
                    "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "16:15",
                    "member_name": "Elmiro Santos Resende",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Presidente",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "n3EoDSuxQZNObutTSI6s",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "H0Irl3nE6l4FdglR3q2L",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TAVI - Estado da Arte",
                    "text": "",
                    "startTime": "16:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "8xaAN7yNUDDOVNkWcgFG",
                        "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "André Raimundo Franca Guimarães ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GxgkmkWhlSGypyIvmZFq",
                        "topic_name": "TAVI - Estado da Arte",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "H0Irl3nE6l4FdglR3q2L",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "QIhdlFZ6s05S2EYnR08Y",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "mUzXuTkF8obNR2aLXn4G",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Tratamento cirúrgico da fibrilação atrial",
                    "text": "",
                    "startTime": "16:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "AyPWyjglsR4mrVNdrhUc",
                        "topic_duration": "15",
                        "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Flávio Donizete Gonçalves ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Tratamento cirúrgico da fibrilação atrial",
                        "activity_id": "GxgkmkWhlSGypyIvmZFq",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "mUzXuTkF8obNR2aLXn4G",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "roJMIMrxIZp40KVuSIIv",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Cirurgia minimamente invasiva - Atualização",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "JUoLceN6nVddGAiBiJzn",
                        "topic_duration": "15",
                        "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Ricardo Adala Benfatti ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GxgkmkWhlSGypyIvmZFq",
                        "topic_name": "Cirurgia minimamente invasiva - Atualização",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "roJMIMrxIZp40KVuSIIv",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "w8oMDp3HPSqVx0NfEADz",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "GxgkmkWhlSGypyIvmZFq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Pacientes frágeis submetidos a revascularização do miocárdio com e sem CEC - Complicações",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "zBRq29FRxF3333IY3Cec",
                        "activity_name": "DEPEX - MESA REDONDA - PESQUISA EM CIRURGIA CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Mauricio Landulfo Jorge Guerrieri",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "GxgkmkWhlSGypyIvmZFq",
                        "topic_name": "Pacientes frágeis submetidos a revascularização do miocárdio com e sem CEC - Complicações",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "w8oMDp3HPSqVx0NfEADz",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "J2VoUKVKtAieh3SM6sds",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p><p>Para os tópicos com Apresentação de caso clínico, o objetivo é que cada palestrante apresente um vídeo de um caso seu para discussão com a mesa</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                    "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Vinicius José da Silva Nina",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "a8vPgddB3sABR4c6X0xF",
                    "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Daniel Hoyer de Carvalho Barcellos ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "3gCNu4s2liL1Zkz20TRc",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:40",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "HeOD88RoKZrl9Dh2Spai",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Apresentação de caso clínico",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "RzhhxnIjXUFxXnBViKDk",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Fernando Antibas Atik ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "J2VoUKVKtAieh3SM6sds",
                        "topic_name": "Apresentação de caso clínico",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "HeOD88RoKZrl9Dh2Spai",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "MIbM0GhRfkcqgyZmNKKp",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Apresentação, classificação e investigação diagnóstica",
                    "text": "",
                    "startTime": "14:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "1RzXU2btisOFnMj7JB3p",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Lúcia Salerno",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "J2VoUKVKtAieh3SM6sds",
                        "topic_name": "Apresentação, classificação e investigação diagnóstica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "MIbM0GhRfkcqgyZmNKKp",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "O7G73CrZplFBxawPy4LI",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Apresentação de caso clínico",
                    "text": "",
                    "startTime": "15:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "Y9UL5zc8uOu7hUxm1O41",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Denoel Marcelino Oliveira ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Apresentação de caso clínico",
                        "activity_id": "J2VoUKVKtAieh3SM6sds",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "O7G73CrZplFBxawPy4LI",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "eE8OrLQk4efAd5ldCHVA",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Apresentação de caso clínico",
                    "text": "",
                    "startTime": "14:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "pwRGgdGInnHNtmVajJLN",
                        "topic_duration": "20",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carla Tanamati ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Apresentação de caso clínico",
                        "activity_id": "J2VoUKVKtAieh3SM6sds",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "eE8OrLQk4efAd5ldCHVA",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "wQ3pey55jfFRTbYkyzzN",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "J2VoUKVKtAieh3SM6sds",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Estratégias e opções terapêuticas",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "ZebI3mSmhsWZHYTKRcsw",
                        "activity_name": "DCCVPED - MISCELÂNEA - MESA REDONDA - ATRESIA PULMONAR COM CIV E COLATERAIS AORTO-PULMONARES",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Renato Abdala Karam Kalil ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "J2VoUKVKtAieh3SM6sds",
                        "topic_name": "Estratégias e opções terapêuticas",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "wQ3pey55jfFRTbYkyzzN",
                        "activity_location": "Auditório 3",
                        "topic_startTime": "14:00"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "KOW8NlsLtxfvtHrI6n1V",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Área de Exposição",
                "name": "INTERVALO",
                "text": "",
                "startTime": "16:00",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "tCR1Pzn1HIAyUNwNNBPB",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "KOW8NlsLtxfvtHrI6n1V",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Visita aos Expositores",
                    "text": "",
                    "startTime": "16:00",
                    "duration": "15",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "LaEG8IfTqrrcSj9Hn4nM",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "w2FOStkDwJQYLGRSCFVi",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Elias Kallás ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4",
                    "role_name": "Coordenador(a)",
                    "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                  },
                  {
                    "member_id": "SV8aQrmdso9sBTBL6zU0",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Alfredo Inácio Fiorelli ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4",
                    "role_name": "Coordenador(a)",
                    "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "74jrubGnvd0WaTrDwwqg",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:45",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "A40XZdPoMThCxw8FspCW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Revascularização do miocárdio minimamente invasiva",
                    "text": "",
                    "startTime": "14:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "JUoLceN6nVddGAiBiJzn",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ricardo Adala Benfatti ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "topic_name": "Revascularização do miocárdio minimamente invasiva",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "A40XZdPoMThCxw8FspCW",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "CNotc2T4IiZeCRJ2mwmR",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Reoperações em adultos com Tetralogia de Fallot",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "m7hFAW6dwk2YCb4qDre1",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Acrísio Sales Valente",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "topic_name": "Reoperações em adultos com Tetralogia de Fallot",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "CNotc2T4IiZeCRJ2mwmR",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "MLE1558QpMQO1OUHMvXO",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Correção cirúrgica dos corações univentriculares",
                    "text": "",
                    "startTime": "14:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pw7FmMZMBTtsbcRfAVBk",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "José Teles de Mendonça ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "topic_name": "Correção cirúrgica dos corações univentriculares",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "MLE1558QpMQO1OUHMvXO",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "MaG88gFffp3zGWcOvY14",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Lesão coronária de tronco. Qual a melhor opção?",
                    "text": "",
                    "startTime": "15:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "3PGBHb0C3UO8TXp9gDM2",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Jocerlano Santos de Sousa ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Lesão coronária de tronco. Qual a melhor opção?",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "MaG88gFffp3zGWcOvY14",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "NSDQSqv9rUpySlCAul6m",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Cirurgia valvar minimamente invasiva",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "Nci7AIXDEKQ27UR2Ryfu",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carlos Manuel de Almeida Brandão ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "topic_name": "Cirurgia valvar minimamente invasiva",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "NSDQSqv9rUpySlCAul6m",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "sGjv2Kk6ZQDuDavHtHbz",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Ainda existe lugar para o transplante heterotópico?",
                    "text": "",
                    "startTime": "14:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ifgnNJhEmY84MFU1gQjF",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "José Wanderley Neto ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Ainda existe lugar para o transplante heterotópico?",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "sGjv2Kk6ZQDuDavHtHbz",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "tfxDHzb7erxd4sUBFftx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Empaglifozina e seus efeitos no cardiomiócito. Novas fronteiras",
                    "text": "",
                    "startTime": "15:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "6QhCu4fetYPObhxJwL59",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Samir Saadeddine Junior ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "LaEG8IfTqrrcSj9Hn4nM",
                        "topic_name": "Empaglifozina e seus efeitos no cardiomiócito. Novas fronteiras",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "tfxDHzb7erxd4sUBFftx",
                        "activity_location": "Auditório 4",
                        "activity_name": "DECARDIO - MESA REDONDA I - ATUALIDADES NAS AFECÇÕES CARDIOVASCULARES"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "RlP93MjXKKmKIcEYUg63",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "16:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "D2cTwd9pATkdowb98vkW",
                    "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "16:15",
                    "member_name": "Nadja Cecília de Castro Kraychete ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "mhJB0SuYtcugC3F5N1MT",
                    "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "16:15",
                    "member_name": "Paulo Roberto Lunardi Prates ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "8ogVoexE2tuVBnmkdywu",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Caso 3 -  TGA com anomalia de arco aórtico (CoAo, Hipoplasia de arco ou IAA)",
                    "text": "",
                    "startTime": "16:35",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "9Wur5mlBxqRBsiC0ZPdP",
                        "topic_duration": "10",
                        "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Luciana Fonseca da Silva",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "RlP93MjXKKmKIcEYUg63",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "8ogVoexE2tuVBnmkdywu",
                        "topic_name": "Caso 3 -  TGA com anomalia de arco aórtico (CoAo, Hipoplasia de arco ou IAA)",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "CXG4WDBMxEsWFNBqy15j",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "30",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "M4Y8h9thm5JaKYZRmXzI",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Caso 4 - Complicações tardias - Manejo clínico",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pwRGgdGInnHNtmVajJLN",
                        "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Carla Tanamati ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "RlP93MjXKKmKIcEYUg63",
                        "topic_name": "Caso 4 - Complicações tardias - Manejo clínico",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "M4Y8h9thm5JaKYZRmXzI",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "SGPqiWjDIeexFeTgNnqT",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Caso 1 -  TGA com anomalia de coronária",
                    "text": "",
                    "startTime": "16:15",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "HiKwZGC9JxBw28x7X1ub",
                        "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Beatriz Helena S. Furlanetto ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "RlP93MjXKKmKIcEYUg63",
                        "topic_name": "Caso 1 -  TGA com anomalia de coronária",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "SGPqiWjDIeexFeTgNnqT"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "ubM5JDglxe79K0AdZ760",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "RlP93MjXKKmKIcEYUg63",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Caso 2 -  TGA + VSD + LVOTO",
                    "text": "",
                    "startTime": "16:25",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "RMgYjWDJG31XBgtBOMP2",
                        "activity_name": "DCCVPED - MISCELÂNEA - FÓRUM TGA - CASOS COMPLEXOS",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "José Pedro da Silva ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:25",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "RlP93MjXKKmKIcEYUg63",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ubM5JDglxe79K0AdZ760",
                        "topic_name": "Caso 2 -  TGA + VSD + LVOTO",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "SGLqFE2sEoqmQiJVD8iD",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "SESSÃO DE TEMAS LIVRES II",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "urqa8kheZfSyrtQUcRh6",
                    "activity_name": "SESSÃO DE TEMAS LIVRES II",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Luiz Cláudio Moreira Lima ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "5iuEbKBK6LwbyajBciiS",
                    "activity_name": "SESSÃO DE TEMAS LIVRES II",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Alexandre Noboru Murakami ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "1UUChW7PfMPm7iSVhHW5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL09 - Impacto da lesão de tronco de coronária esquerda nos resultados perioperatórios da cirurgia de revascularização do miocárdio isolada: análise de uma coorte prospectiva de oito anos",
                    "text": "<p><i><strong>Autor(es): </strong>Álvaro Rösler, Gustavo Ferreira, Vinicius Prediger, Jonathan Fraportti, Marcela da Cunha Sales, Fernando Lucchese</i></p><p><br><i><strong>Instituição: </strong>Hospital São Francisco - Centro de Pesquisas em Cirurgia Cardiovascular (RS)</i></p>",
                    "startTime": "08:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "PKjfvOcxsrIemox3jl4E",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Mauro Barbosa Arruda Filho ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL09 - Impacto da lesão de tronco de coronária esquerda nos resultados perioperatórios da cirurgia de revascularização do miocárdio isolada: análise de uma coorte prospectiva de oito anos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "1UUChW7PfMPm7iSVhHW5",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "4l3989WUqEkyDScf47UK",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Marcela da Cunha Sales ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL09 - Impacto da lesão de tronco de coronária esquerda nos resultados perioperatórios da cirurgia de revascularização do miocárdio isolada: análise de uma coorte prospectiva de oito anos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "1UUChW7PfMPm7iSVhHW5",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "BdXvfpuLPEEuZmQvkcxI",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL10 - Desenvolvimento de modelos de cardiopatias congênitas em impressão 3D - Avaliação no potencial de ensino da Cardiologia e Cirurgia Cardiovascular Pediátrica",
                    "text": "<p><i><strong>Autor(es):</strong> Francisco Cândido Monteiro Cajueiro, Ulisses Alexandre Croti, Raimundo Francisco de Amorim Júnior, Mariana Ribeiro Rodero Cardoso, Carlos Henrique Costa, Carlos Henrique De Marchi</i></p><p><br><i><strong>Instituição: </strong>CardioPedBrasil® - Centro do Coração da Criança, Hospital da Criança e Maternidade de São José do Rio Preto - FUNFARME/FAMERP (SP)</i></p>",
                    "startTime": "08:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "hOjm1xPd5AmcQ3R8AQiS",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Francisco Candido Monteiro Cajueiro",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "BdXvfpuLPEEuZmQvkcxI",
                        "topic_startTime": "08:45",
                        "topic_name": "TL10 - Desenvolvimento de modelos de cardiopatias congênitas em impressão 3D - Avaliação no potencial de ensino da Cardiologia e Cirurgia Cardiovascular Pediátrica",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "G7lcUh6ajYPZpR2Xf60Y",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Wilson Luiz da Silveira ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador(a)",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL10 - Desenvolvimento de modelos de cardiopatias congênitas em impressão 3D - Avaliação no potencial de ensino da Cardiologia e Cirurgia Cardiovascular Pediátrica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "BdXvfpuLPEEuZmQvkcxI",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "e064AicBh7ossfXjq5X5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL15 - Cirurgia minimamente invasiva e plastia mitral RESPECT - avaliação de médio prazo",
                    "text": "<p><i><strong>Autor(es):</strong> Francisco Fernandes Moreira Neto, Maria Rita F. S. Moreira, Celso Reis Ávila, Cecílio A. Barbosa Jacob, Antônio Carlos Menardi</i></p><p><br><i><strong>Instituição: </strong>HURP e Hospital São Lucas de Ribeirão Preto (SP)</i></p>",
                    "startTime": "10:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "HWMRxbVpf4S0EkTfBuPo",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Francisco Fernandes Moreira Neto ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "10:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "e064AicBh7ossfXjq5X5",
                        "topic_name": "TL15 - Cirurgia minimamente invasiva e plastia mitral RESPECT - avaliação de médio prazo",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "xBlS67SuCxOdyLWhi7zs",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Nelson Américo Hossne Júnior ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "10:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL15 - Cirurgia minimamente invasiva e plastia mitral RESPECT - avaliação de médio prazo",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "e064AicBh7ossfXjq5X5",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "effUAW7Lyw8Ho83ui7F1",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL13 - Hipertensão pulmonar extrema pré-operatória: impacto nos desfechos da cirurgia de troca valvar mitral",
                    "text": "<p><i><strong>Autor(es): </strong>Luiz Rafael Pereira Cavalcanti, Álvaro M. Perazzo, Antônio C. Escorel de A. Neto, Paulo Guilherme B. Braga, Alexandre M. de Menezes, Francisco C. Monteiro Cajueiro</i></p><p><br><i><strong>Instituto: </strong>Departamento de Cirurgia Cardiovascular do Pronto Socorro Cardiológico de Pernambuco – PROCAPE, Universidade de Pernambuco (PE)</i></p>",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "QSshnDERt5TfEgyewOjg",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Ricardo Barros Corso ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL13 - Hipertensão pulmonar extrema pré-operatória: impacto nos desfechos da cirurgia de troca valvar mitral",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "effUAW7Lyw8Ho83ui7F1",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "TM7fw84BEFJbyhCS8cZN",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Luiz Rafael Pereira Cavalcanti",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "effUAW7Lyw8Ho83ui7F1",
                        "topic_name": "TL13 - Hipertensão pulmonar extrema pré-operatória: impacto nos desfechos da cirurgia de troca valvar mitral",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "fyc0WVyLnX4H6h4R87K0",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL16 - Avaliação da qualidade de vida em pacientes pediátricos submetidos a implante de marcapasso cardíaco definitivo epicárdico",
                    "text": "<p><i><strong>Autor(es): </strong>Acrisio Sales Valente, Rebeka Ventura Pessoa de Paula, Rafaela Montenegro Aires Sampaio, Isabella Timbó Queiroz, Klébia Magalhães Pereira Castello Branco, Stela Maria Vitorino Sampaio</i></p><p><br><i><strong>Instituição:</strong> Hospital de Messejana Dr. Carlos Alberto Studart Gomes Centro Universitário Unichristus (CE)</i></p>",
                    "startTime": "10:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "5YxlBHAfgpiuHI67JHKZ",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "George Ronald Soncini da Rosa ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL16 - Avaliação da qualidade de vida em pacientes pediátricos submetidos a implante de marcapasso cardíaco definitivo epicárdico",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fyc0WVyLnX4H6h4R87K0",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "m7hFAW6dwk2YCb4qDre1",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Acrísio Sales Valente",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fyc0WVyLnX4H6h4R87K0",
                        "topic_name": "TL16 - Avaliação da qualidade de vida em pacientes pediátricos submetidos a implante de marcapasso cardíaco definitivo epicárdico",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "jOOeJ83TxSkckdTnEksV",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL12 - Fibrilação atrial após cirurgia de revascularização miocárdica e sua relação com complicações hospitalares: análise do Registro Paulista de Cirurgia Cardiovascular (REPLICCAR II)",
                    "text": "<p><i><strong>Autor(es): </strong>Adnaldo da Silveira Maia, Dayara Hoffmann Mayer, Renê Augusto Gonçalves e Silva, Matheus da Silveira Maia, Omar Asdrubal Vilca Mejia, Grupo de estudo REPLICCAR</i></p><p><br><i><strong>Instituição:</strong> Instituto Dante Pazzanese de Cardiologia (SP)</i></p>",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "TawRmR2TVs1QsxUf0Ah3",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Marcos Gradim Tiveron ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador(a)",
                        "topic_startTime": "09:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL12 - Fibrilação atrial após cirurgia de revascularização miocárdica e sua relação com complicações hospitalares: análise do Registro Paulista de Cirurgia Cardiovascular (REPLICCAR II)",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jOOeJ83TxSkckdTnEksV",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "pYmMGn81MHYnGsJ2dpVo",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Adnaldo da Silveira Maia",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jOOeJ83TxSkckdTnEksV",
                        "topic_name": "TL12 - Fibrilação atrial após cirurgia de revascularização miocárdica e sua relação com complicações hospitalares: análise do Registro Paulista de Cirurgia Cardiovascular (REPLICCAR II)",
                        "topic_startTime": "09:15",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "q6Xlo9N5y8MinQOBqG2u",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL14 - Hemoadsorção na endocardite infecciosa e circulação extracorpórea: resultados clínicos, experiência inicial",
                    "text": "<p><i><strong>Autor(es): </strong>Camilo Rodriguez, Francisco Mauricio Rincón Tello, Aura María Rivera Herrera, Javier Francisco Orozco Gómez, Raquel Sofía López Rincón</i></p><p><br><i><strong>Instituição:</strong> Clinica Los Nogales. Bogotá, Colombia</i></p>",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7uJIuPolgj8OquFyX37S",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Francisco Mauricio Rincon Tello",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "topic_startTime": "09:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL14 - Hemoadsorção na endocardite infecciosa e circulação extracorpórea: resultados clínicos, experiência inicial",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "q6Xlo9N5y8MinQOBqG2u",
                        "role_name": " Apresentador(a) ",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "0HKGwQwroXpkyJLzp9Sh",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Laio Caju Wanderley",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "09:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL14 - Hemoadsorção na endocardite infecciosa e circulação extracorpórea: resultados clínicos, experiência inicial",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "q6Xlo9N5y8MinQOBqG2u",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "zIaelRB2AH8OYvRrpOSK",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "TL11 - Resultados tardios da Operação de Ross em pacientes com moléstia reumática",
                    "text": "<p><i><strong>Autor(es):</strong> Ana Beatriz Brenner Affonso da Costa Rea, Miguel Morita Fernandes-Silva, Claudinei Colatusso, Carolina Limongi Oliveira, Eduardo Leal Adam, Francisco Diniz Affonso da Costa</i></p><p><br><i><strong>Instituição: </strong>Instituto de Neurologia e Cardiologia de Curitiba (PR)</i></p>",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "aeAXojZaiP0xuZRu1Ioc",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Carolina Limongi Oliveira",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "topic_name": "TL11 - Resultados tardios da Operação de Ross em pacientes com moléstia reumática",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "zIaelRB2AH8OYvRrpOSK",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "nogq5P5D7b3aSVHF6goW",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO DE TEMAS LIVRES II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Milton de Miranda Santoro ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Comentador",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL11 - Resultados tardios da Operação de Ross em pacientes com moléstia reumática",
                        "activity_id": "SGLqFE2sEoqmQiJVD8iD",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "zIaelRB2AH8OYvRrpOSK",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "VUw3Yb3eNsHzBhTZP0uO",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "DECEM - MESA REDONDA - MICS",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "momWB9r97qBCF7ipcNZ0",
                    "activity_name": "DECEM - MESA REDONDA - MICS",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Anderson da Silva Terrazas ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "4l3989WUqEkyDScf47UK",
                    "activity_name": "DECEM - MESA REDONDA - MICS",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Marcela da Cunha Sales ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "5UGktHebz3HxRXct8AEJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na revascularização miocárdica",
                    "text": "",
                    "startTime": "14:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "IFFBOlR2QfHhXOk6FbdY",
                        "topic_duration": "20",
                        "activity_name": "DECEM - MESA REDONDA - MICS",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Waldo Emerson Pinheiro Daniel",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                        "topic_name": "Na revascularização miocárdica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "5UGktHebz3HxRXct8AEJ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "677ZSC07FmiymTTTJUEF",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:20",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "W1Cpt8xnRNRZcMhITMdl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na plastia valvar mitral",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                        "activity_name": "DECEM - MESA REDONDA - MICS",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Magaly Arrais dos Santos",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                        "topic_name": "Na plastia valvar mitral",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "W1Cpt8xnRNRZcMhITMdl"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "XnkSlINu2a9IHa2ZVHtX",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na ressecção de aneurismas de aorta ascendente",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "QSshnDERt5TfEgyewOjg",
                        "topic_duration": "20",
                        "activity_name": "DECEM - MESA REDONDA - MICS",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ricardo Barros Corso ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Na ressecção de aneurismas de aorta ascendente",
                        "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "XnkSlINu2a9IHa2ZVHtX",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "eJF2b4aZsWMbFt5nOnRo",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Na troca valvar aórtica",
                    "text": "",
                    "startTime": "14:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "5YxlBHAfgpiuHI67JHKZ",
                        "activity_name": "DECEM - MESA REDONDA - MICS",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "George Ronald Soncini da Rosa ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "VUw3Yb3eNsHzBhTZP0uO",
                        "topic_name": "Na troca valvar aórtica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "eJF2b4aZsWMbFt5nOnRo",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "Y1gcERNo3n5uHnw3rgSq",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "BTlpXRTvn56uWDHODHh2",
                    "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Fabio Biscegli Jatene ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                    "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Vinicius José da Silva Nina",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "1ZP0PWPGto10yAoZX12Q",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Reoperação em cirurgia da aorta torácica / Redo thoracic aortic surgery",
                    "text": "",
                    "startTime": "09:10",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "5RjK5uDeRbIyXkGQpq9m",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Roberto Di Bartolomeo",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:10",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "topic_name": "Reoperação em cirurgia da aorta torácica / Redo thoracic aortic surgery",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "1ZP0PWPGto10yAoZX12Q",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "63uxxEc5M8cUsI30KtQn",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Medidas de segurança na cirurgia de revascularização do miocárdio / Safety adjuncts in coronary artery bypass surgery",
                    "text": "",
                    "startTime": "08:50",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "YcEGvs1EHY5MaUR0DcWL",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Rodrigo Coelho Segalote ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "topic_name": "Medidas de segurança na cirurgia de revascularização do miocárdio / Safety adjuncts in coronary artery bypass surgery",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "63uxxEc5M8cUsI30KtQn"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "6YBrM9pYCPGSXb39sNxF",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "A análise da mortalidade por etapas do cuidado é uma estratégia para melhoria da qualidade em programas cirúrgicos globais? / Is phase of care mortality analysis a strategy for quality improvement in global surgical programs?",
                    "text": "",
                    "startTime": "09:50",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "AfGK5WdgVzoI0ZMUrrTA",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Emily Farkas",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "6YBrM9pYCPGSXb39sNxF",
                        "topic_name": "A análise da mortalidade por etapas do cuidado é uma estratégia para melhoria da qualidade em programas cirúrgicos globais? / Is phase of care mortality analysis a strategy for quality improvement in global surgical programs?",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "edaW0EtulNOJd9QzX89t",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Segurança em cirurgia valvar mitral na atualidade / Safety of mitral valve surgery in the present era",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "D95i2ch1buGrZQBouOuA",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Manuel J. Antunes",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "topic_name": "Segurança em cirurgia valvar mitral na atualidade / Safety of mitral valve surgery in the present era",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "edaW0EtulNOJd9QzX89t",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "mC50iS9ifUYRO5oIEkT2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "10:30",
                    "duration": "10",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "vjHDAnB3rtxYAoshgVqF",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Implementação do ERAS em  Programas de Cirurgia Cardíaca / Implementation of ERAS in Cardiac Surgical Programs",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "LGhSU3EWefWIrNY8DH39",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Omar Asdrubal Vilca Mejia ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "vjHDAnB3rtxYAoshgVqF",
                        "activity_location": "Auditório 4",
                        "topic_name": "Implementação do ERAS em  Programas de Cirurgia Cardíaca / Implementation of ERAS in Cardiac Surgical Programs"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "w3KuZ8wmZIxIGyjpZlES",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Segurança do paciente na sala de cirurgia cardíaca / Patient Safety in the cardiac operating room",
                    "text": "",
                    "startTime": "10:10",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "UFJ3Ac1G2vumQDKpdZpH",
                        "activity_name": "MESA REDONDA VII -   ATUALIZAÇÕES EM SEGURANÇA NA CIRURGIA CARDIOVASCULAR /ROUND TABLE VII - CONTEMPORARY SAFETY UPDATES IN CARDIOVASCULAR SURGERY",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Mário Ricardo Amar ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "10:10",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Y1gcERNo3n5uHnw3rgSq",
                        "topic_name": "Segurança do paciente na sala de cirurgia cardíaca / Patient Safety in the cardiac operating room",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "w3KuZ8wmZIxIGyjpZlES",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "aRh4h1glJwyMYYGZbxxc",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "16:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "UyaVScV1eqscIewX3Hl9",
                    "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "16:15",
                    "member_name": "Marcelo Sávio da Silva Martins",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "momWB9r97qBCF7ipcNZ0",
                    "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Anderson da Silva Terrazas ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "bB6FIrdXxiQUZ3Cb2RGf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Tratamento sequencial da dissecção aórtica do Tipo B",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "tHqDojmyXOjvWTwUc3OD",
                        "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Rodrigo de Castro Bernardes ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "aRh4h1glJwyMYYGZbxxc",
                        "topic_name": "Tratamento sequencial da dissecção aórtica do Tipo B",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "bB6FIrdXxiQUZ3Cb2RGf"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "fVVeSLSN4ZnBDg5INw8d",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "k0HTFS2xwl5OtheeNov1",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Estado atual da valva mitral transcateter",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "U75AfgIWBMJIX8J6CWzb",
                        "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Renato Bastos Pope ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "aRh4h1glJwyMYYGZbxxc",
                        "topic_name": "Estado atual da valva mitral transcateter",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "k0HTFS2xwl5OtheeNov1"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kDMMHb6F75sRFL18ybkl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Contraindicações absolutas e relativas ao uso de TAVI para tratar estenose aórtica",
                    "text": "",
                    "startTime": "16:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "U75AfgIWBMJIX8J6CWzb",
                        "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Renato Bastos Pope ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Contraindicações absolutas e relativas ao uso de TAVI para tratar estenose aórtica",
                        "activity_id": "aRh4h1glJwyMYYGZbxxc",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kDMMHb6F75sRFL18ybkl",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "ul6MBt4BrQyoLpNBavR0",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "aRh4h1glJwyMYYGZbxxc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Importância da imagem para programação de cirurgia endovascular",
                    "text": "",
                    "startTime": "16:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "JyS5Mj4rUgRaqWTRMXRx",
                        "activity_name": "DECEM - MESA REDONDA - ENDOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Cledicyon Eloy da Costa",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "aRh4h1glJwyMYYGZbxxc",
                        "topic_name": "Importância da imagem para programação de cirurgia endovascular",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ul6MBt4BrQyoLpNBavR0",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "bZnynFiSJX7Fc0Ep4e9G",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                    "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Magaly Arrais dos Santos",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "urqa8kheZfSyrtQUcRh6",
                    "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Luiz Cláudio Moreira Lima ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "48e2VgRWuskPVqcjLxoB",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "O papel dos mentores na formação dos novos cirurgiões cardiovasculares",
                    "text": "",
                    "startTime": "11:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "pHopGlaMmGboS9s4ZJPk",
                        "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "O papel dos mentores na formação dos novos cirurgiões cardiovasculares",
                        "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "48e2VgRWuskPVqcjLxoB",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "5HoVQonO5mckmrGGFDaQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "12:30",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "S6iyJwrMIuDmqarfIMvp",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "A Residência Médica em Cirurgia Cardiovascular com acesso direto. A experiência do Brasil",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "SFNBoq7e9WXbhS4DRrSh",
                        "topic_duration": "20",
                        "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Davi Freitas Tenório",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "S6iyJwrMIuDmqarfIMvp",
                        "activity_location": "Auditório 2",
                        "topic_name": "A Residência Médica em Cirurgia Cardiovascular com acesso direto. A experiência do Brasil"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "lVxSfep4gxLSwWbCNyVf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "O papel das Ligas Acadêmicas na formação do cirurgião cardiovascular",
                    "text": "",
                    "startTime": "11:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "itXzdpYWGmRbIx1k3tdE",
                        "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Rômulo César Arnal Bonini",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                        "topic_name": "O papel das Ligas Acadêmicas na formação do cirurgião cardiovascular",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "lVxSfep4gxLSwWbCNyVf",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "mGrwAnlYIFmtiK2r4JHB",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Cor e Kosmos. Anatomia do coração humano. Uma reflexão estética",
                    "text": "",
                    "startTime": "12:00",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "NbntlbJxTs49lEMcL94l",
                        "topic_duration": "30",
                        "activity_name": "MESA REDONDA VI - EDUCAÇÃO MÉDICA",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Luiz Antonio Rivetti ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "12:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bZnynFiSJX7Fc0Ep4e9G",
                        "topic_name": "Cor e Kosmos. Anatomia do coração humano. Uma reflexão estética",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "mGrwAnlYIFmtiK2r4JHB",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "bbP7Q8NzoTIDKfvaCQ8U",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "eLHjvjnNT7rXm3fCSSUa",
                    "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Ana Maria Rocha Pinto e Silva ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "U75AfgIWBMJIX8J6CWzb",
                    "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Renato Bastos Pope ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "2eiuYo5XkWXMQPjYRhwn",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Quando indicar sutureless valve ou TAVI em pacientes com anel valvar pequeno? / When to indicate sutureless valve or TAVI in small aortic annulus?",
                    "text": "",
                    "startTime": "11:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "D9OFMMa4b6zhRZ90JGDg",
                        "topic_duration": "15",
                        "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Giuseppe Bruschi",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                        "topic_name": "Quando indicar sutureless valve ou TAVI em pacientes com anel valvar pequeno?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "2eiuYo5XkWXMQPjYRhwn",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "QqvxlZSxkrV8Vt0oLtGn",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Qual o paciente ideal para o uso de mitraclip?",
                    "text": "",
                    "startTime": "11:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "vklFqYm25ki5o1mzphiQ",
                        "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Eduardo Keller Saadi ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "QqvxlZSxkrV8Vt0oLtGn",
                        "topic_name": "Qual o paciente ideal para o uso de mitraclip?",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "SV6OrVd3SuwqrDFPEZ94",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Indicações de tratamento transcateter para FOP e CIA",
                    "text": "",
                    "startTime": "11:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7qi2vEYdO3teszgHsWwG",
                        "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Heraldo Guedis Lobo Filho ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Indicações de tratamento transcateter para FOP e CIA",
                        "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "SV6OrVd3SuwqrDFPEZ94",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "VohhYJDpFtYAteJvj8Ds",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Manejo da estenose aórtica grave sintomática em pacientes jovens",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                        "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Vinicius José da Silva Nina",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Manejo da estenose aórtica grave sintomática em pacientes jovens",
                        "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "VohhYJDpFtYAteJvj8Ds",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "bJThLG2ooQMN53FZ5BnB",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Houve redução no implante de marcapasso com os novos modelos de próteses aórticas transcatéteres?",
                    "text": "",
                    "startTime": "12:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "5yrGDXcl3mMyHZSJbuow",
                        "activity_name": "MESA REDONDA IV - DEFEITOS ESTRUTURAIS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "José Honório de Almeida Palma Fonseca",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "12:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                        "topic_name": "Houve redução no implante de marcapasso com os novos modelos de próteses aórticas transcatéteres?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "bJThLG2ooQMN53FZ5BnB",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "cYHhNZSEE9WCobyRwn3X",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "bbP7Q8NzoTIDKfvaCQ8U",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "12:15",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "clLs5fcIepRPk9hhw6yF",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "SESSÃO COMO EU FAÇO",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "keFvoyoOACgEM8bxAcmx",
                    "activity_name": "SESSÃO COMO EU FAÇO",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": false,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Henrique Madureira da Rocha Coutinho ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "event_name": "49º Congresso da SBCCV • 2023"
                  },
                  {
                    "member_id": "HbH1jwatZQm6ly3bOqFo",
                    "activity_name": "SESSÃO COMO EU FAÇO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Eduardo Augusto Victor Rocha",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "4HcTecMNGsqPFlC3Bg31",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Explante de TAVI",
                    "text": "",
                    "startTime": "11:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "mhJB0SuYtcugC3F5N1MT",
                        "topic_duration": "20",
                        "activity_name": "SESSÃO COMO EU FAÇO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Paulo Roberto Lunardi Prates ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "clLs5fcIepRPk9hhw6yF",
                        "topic_name": "Explante de TAVI",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "4HcTecMNGsqPFlC3Bg31",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "aN5XqXZf5wWARvtvyQ13",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "12:20",
                    "duration": "25",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "dN6OJqREPp2CXCeMNCLa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "MICS na troca valvar áortica e aneurisma de aorta ascendente",
                    "text": "",
                    "startTime": "11:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "MarhnVGRhL3kSSe6uWVY",
                        "activity_name": "SESSÃO COMO EU FAÇO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Marco Antonio Praça Oliveira ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "clLs5fcIepRPk9hhw6yF",
                        "topic_name": "MICS na troca valvar áortica e aneurisma de aorta ascendente",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dN6OJqREPp2CXCeMNCLa",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "jnHCyXPSvaaE8fQvGTUK",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Reoperação em coronária com mamária pérvia",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "VbemlUiQZS2XiFQdu4NW",
                        "activity_name": "SESSÃO COMO EU FAÇO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Fernando Antonio Lucchese ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "clLs5fcIepRPk9hhw6yF",
                        "topic_name": "Reoperação em coronária com mamária pérvia",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jnHCyXPSvaaE8fQvGTUK",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pyYyWmpvnAGb3vfdjlUU",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "clLs5fcIepRPk9hhw6yF",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Reoperação de Bentall De Bono",
                    "text": "",
                    "startTime": "12:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "9k0EGRTP67Xcz878MBZa",
                        "activity_name": "SESSÃO COMO EU FAÇO",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Ricardo Ribeiro Dias ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "12:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "clLs5fcIepRPk9hhw6yF",
                        "topic_name": "Reoperation after Bentall-De Bono",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "pyYyWmpvnAGb3vfdjlUU",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "gKxZ6VEiKWQDg4e8ioEP",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p>Nessa sessão, o objetivo é que cada palestrante apresente um vídeo de um caso seu para discussão com a mesa</p>",
                "startTime": "09:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                    "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "09:30",
                    "member_name": "Pedro Rafael Salerno ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "6QisZ6kM0eraJV2egjJa",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Moderador(a)",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "G7lcUh6ajYPZpR2Xf60Y",
                    "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "09:30",
                    "member_name": "Wilson Luiz da Silveira ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "6QisZ6kM0eraJV2egjJa",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Moderador(a)",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "EdNL347z3PeSZrQhaF86",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Vídeo 4 - Norwood-Sano",
                    "text": "",
                    "startTime": "10:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "tTSG956F1D7kvRqE2par",
                        "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Rodrigo Freire Bezerra",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                        "topic_name": "Vídeo 4 - Norwood-Sano",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "EdNL347z3PeSZrQhaF86",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "SrgRcm2TMWYcH11LOdhl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Vídeo 1  - Norwood-Sano",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "LapyFJ6x4PKGq7qMfbdg",
                        "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Leonardo Augusto Miana",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                        "topic_name": "Vídeo 1  - Norwood-Sano",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "SrgRcm2TMWYcH11LOdhl",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "TMy1kEs6Vl3f3tKhEs8w",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Vídeo 2  - Norwood-Sano/Híbrido",
                    "text": "",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7wgRccFQiSVeGruP4z8c",
                        "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Fábio Binhara Navarro ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "09:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "topic_name": "Vídeo 2  - Norwood-Sano/Híbrido",
                        "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "TMy1kEs6Vl3f3tKhEs8w",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kFv47Oy1qWGRqU1n5Pt4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Vídeo 3 - Cirurgia de Yassui",
                    "text": "",
                    "startTime": "10:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "HiKwZGC9JxBw28x7X1ub",
                        "activity_name": "DCCVPED - MISCELÂNEA - SESSÃO DE  VÍDEOS (COMO EU FAÇO)",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Beatriz Helena S. Furlanetto ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "topic_startTime": "10:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "activity_id": "gKxZ6VEiKWQDg4e8ioEP",
                        "topic_name": "Vídeo 3 - Cirurgia de Yassui",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kFv47Oy1qWGRqU1n5Pt4",
                        "role_name": " Apresentador(a) ",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "iMQIU8jy51cVltp0H2yP",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "AUDITÓRIO VIRGLÍLIO LOUREIRO",
                "name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "16:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "KGboPJaP8ub7mjron2Qe",
                    "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Fernando Antoniali ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  },
                  {
                    "member_id": "gc4xooMN9XfZiraZBtd0",
                    "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "16:15",
                    "member_name": "Fábio Murilo Costa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "2EkNfnKA9UDevq7h8B8g",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Toda ECMO pós-cardiotomia deve ser central associada à drenagem do átrio esquerdo?",
                    "text": "",
                    "startTime": "16:35",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "KGboPJaP8ub7mjron2Qe",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Fernando Antoniali ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "topic_name": "Toda ECMO pós-cardiotomia deve ser central associada à drenagem do átrio esquerdo?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "2EkNfnKA9UDevq7h8B8g",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "HODcXaLGNO0uJVLaHebP",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Perfusionista é pressurizista! Quem decide qual medicamento deve ou não ser ministrado ao paciente durante a CEC?",
                    "text": "",
                    "startTime": "16:15",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "FtRt4oyy4BZQzQ31XHzi",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Élio Carvalho",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "topic_name": "Perfusionista é pressurizista! Quem decide qual medicamento deve ou não ser ministrado ao paciente durante a CEC?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "HODcXaLGNO0uJVLaHebP",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "KzVMg7QC1h6wxMYSbI0S",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "W7dl9lhYd2CyFhBGq7r5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "ECMO como ponte para transplante deve ser amplamente utilizada?",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "RzhhxnIjXUFxXnBViKDk",
                        "topic_duration": "10",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Fernando Antibas Atik ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "topic_name": "ECMO como ponte para transplante deve ser amplamente utilizada?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "W7dl9lhYd2CyFhBGq7r5",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "YPq1ummZTboFRVz6v9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Disfunção primária do enxerto: o que sabemos e o que não sabemos sobre isso?",
                    "text": "",
                    "startTime": "16:55",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "TNegaNCo8I6SdabN45Gc",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Samuel Padovani Steffen ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:55",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Disfunção primária do enxerto: o que sabemos e o que não sabemos sobre isso?",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "YPq1ummZTboFRVz6v9n5",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pv3hzhH8uYtzVJfmLmAe",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "ECMO é coisa de perfusionista?",
                    "text": "",
                    "startTime": "16:25",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "G4u81CSQPEvxI1wpKB0B",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Edna Rodrigues Bezerra",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:25",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "topic_name": "ECMO é coisa de perfusionista?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "pv3hzhH8uYtzVJfmLmAe",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "yRMq9bJGmMN9oAxFRDKW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "iMQIU8jy51cVltp0H2yP",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Padrões e Diretrizes brasileiras: o que modificou em nossas práticas e na formação de nossos perfusionistas?",
                    "text": "",
                    "startTime": "17:05",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "WGKI17sk9GEzB5jGLfly",
                        "activity_name": "DECAM - RESPOSTAS CURTAS PARA QUESTÕES RELEVANTES",
                        "topic_duration": "10",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "16:15",
                        "member_name": "Flávia Alves",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "iMQIU8jy51cVltp0H2yP",
                        "topic_name": "Padrões e Diretrizes brasileiras: o que modificou em nossas práticas e na formação de nossos perfusionistas?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "yRMq9bJGmMN9oAxFRDKW",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "jqtDssZuZA1vZlHoC6vl",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "DECEM - CONFERÊNCIA - Cirurgia robótica. Como estamos e para onde vamos",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e Conferencista ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "15:40",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZebI3mSmhsWZHYTKRcsw",
                    "activity_name": "DECEM - CONFERÊNCIA - Cirurgia robótica. Como estamos e para onde vamos",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "activity_startTime": "15:40",
                    "member_name": "Renato Abdala Karam Kalil ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "jqtDssZuZA1vZlHoC6vl",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "day_name": "Primeiro Dia",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "VfFO3FTnWduNYdCq9nCY",
                    "activity_name": "DECEM - CONFERÊNCIA - Cirurgia robótica. Como estamos e para onde vamos",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "15:40",
                    "member_name": "Robinson Poffo ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Conferencista",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "uYOH6vwplH1OSKByONkf",
                    "activity_id": "jqtDssZuZA1vZlHoC6vl",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "ghTPRRf3dr3UK5JsKN9H",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "jqtDssZuZA1vZlHoC6vl",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "CONFERÊNCIA - Cirurgia robótica. Como estamos e para onde vamos",
                    "text": "",
                    "startTime": "15:40",
                    "duration": "20",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "mKi8MSsYKNlwnUQB8xjL",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "AUDITÓRIO VIRGLÍLIO LOUREIRO",
                "name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "14:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "Grp7ZpLL5sbcfYJM0t21",
                    "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:30",
                    "member_name": "Luiz Fernando Caneo ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  },
                  {
                    "member_id": "bqnFsDYiw6XBvhquhl0s",
                    "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:30",
                    "member_name": "Fernando Augusto Marinho dos Santos Figueira ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  },
                  {
                    "member_id": "FtRt4oyy4BZQzQ31XHzi",
                    "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:30",
                    "member_name": "Élio Carvalho",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "2X4XKya5mu4u59S1TWRX",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Qualidade e segurança. Onde e como atuar junto aos mecanismos de regulação vigentes",
                    "text": "",
                    "startTime": "15:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "XQHo68joc1U2WXv6f9YQ",
                        "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:30",
                        "member_name": "Luís Antônio Glowacki",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                        "topic_name": "Qualidade e segurança. Onde e como atuar junto aos mecanismos de regulação vigentes",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "2X4XKya5mu4u59S1TWRX",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "5W9ajjXG6DsCA29qwbtQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Distanciamento tecnológico. Os desafios em desenvolver, produzir e comercializar tecnologias amplamente utilizadas no mercado mundial",
                    "text": "",
                    "startTime": "14:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "4UuEErOjcJ2JNdplwTHK",
                        "topic_duration": "15",
                        "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:30",
                        "member_name": "Rafael Braile ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Distanciamento tecnológico. Os desafios em desenvolver, produzir e comercializar tecnologias amplamente utilizadas no mercado mundial",
                        "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "5W9ajjXG6DsCA29qwbtQ",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "ThpTTJ99Uop95YBSMgOW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Distanciamento tecnológico. Os desafios na incorporação no cenário nacional de tecnologias amplamente utilizadas no mercado mundial",
                    "text": "",
                    "startTime": "14:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "2xvOL1PA0xp8CswPFldI",
                        "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:30",
                        "member_name": "Anderson Cocate",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                        "topic_name": "Distanciamento tecnológico. Os desafios na incorporação no cenário nacional de tecnologias amplamente utilizadas no mercado mundial",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ThpTTJ99Uop95YBSMgOW",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pODOXw8OVmFqhmHnscIl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Agências regulatórias. Onde e como podemos atuar na incorporação de novas tecnologias",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "RIoV8U8gshgKI2RHjNh9",
                        "activity_name": "DECAM - MESA REDONDA - INCORPORAÇÃO DE NOVAS TECNOLOGIAS EM CEC - VIVENDO NUM MUSEU DE NOVIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "14:30",
                        "member_name": "Evelinda Trindade",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Agências regulatórias. Onde e como podemos atuar na incorporação de novas tecnologias",
                        "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "pODOXw8OVmFqhmHnscIl",
                        "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "vygU7VFLfe1JyIQFXZZQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mKi8MSsYKNlwnUQB8xjL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:30",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "mLbQvCMFQ4b0xkH1ihPc",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "DEPEX - ABERTURA",
                "text": "",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "AyPWyjglsR4mrVNdrhUc",
                    "activity_name": "DEPEX - ABERTURA",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Flávio Donizete Gonçalves ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "mLbQvCMFQ4b0xkH1ihPc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "A7ft6pdcFNAODAE8lcEs",
                    "activity_name": "DEPEX - ABERTURA",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Henrique Barsanulfo Furtado ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "mLbQvCMFQ4b0xkH1ihPc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "0HRgidpQzdmG7gEidCvE",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "mLbQvCMFQ4b0xkH1ihPc",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "ABERTURA",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "05",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "txDqbEQJCThjm92yJXbk",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Área de Exposição",
                "name": "INTERVALO",
                "text": "",
                "startTime": "10:45",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "RlvspZAZZYlAUaEA4hn8",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "txDqbEQJCThjm92yJXbk",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Visita aos Expositores",
                    "text": "",
                    "startTime": "10:45",
                    "duration": "15",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "vgSziO5ZLVpbA4EEM1tz",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "AUDITÓRIO VIRGLÍLIO LOUREIRO",
                "name": "DECAM - CONFERÊNCIA - Impacto da evolução da circulação extracorpórea no resultado cirúrgico",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "Grp7ZpLL5sbcfYJM0t21",
                    "activity_name": "DECAM - CONFERÊNCIA - Impacto da evolução da circulação extracorpórea no resultado cirúrgico",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Luiz Fernando Caneo ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "activity_id": "vgSziO5ZLVpbA4EEM1tz",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Conferencista",
                    "role_id": "uYOH6vwplH1OSKByONkf",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  },
                  {
                    "member_id": "FtRt4oyy4BZQzQ31XHzi",
                    "activity_name": "DECAM - CONFERÊNCIA - Impacto da evolução da circulação extracorpórea no resultado cirúrgico",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Élio Carvalho",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "vgSziO5ZLVpbA4EEM1tz",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "AUDITÓRIO VIRGLÍLIO LOUREIRO"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "L4fdMlJdOJuOmlqhzE6F",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "vgSziO5ZLVpbA4EEM1tz",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "CONFERÊNCIA - Impacto da evolução da circulação extracorpórea no resultado cirúrgico",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "wHXMJkLIBPfEeVLpKozL",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "DBXFrf5DkWpT2TvjxMNx",
                "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "pWpnxr0dJGFYWgjb5jE9",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Décio Cavalet Soares Abuchaim ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                    "activity_location": "Auditório 3",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "FosE0Q7Hd7wjyEK2oIww",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Ricardo Nilsson Sgarbieri ",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Segundo Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                    "activity_location": "Auditório 3",
                    "role_name": "Coordenador(a)"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "E5vyIROa3z1fQkGypZ7y",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Fechamento esternal tardio. Só quando necessário ou de rotina?",
                    "text": "",
                    "startTime": "11:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "ojVPBcxW6WCnYtTHpsXE",
                        "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "José Cícero Stocco Guilhen ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "wHXMJkLIBPfEeVLpKozL",
                        "topic_name": "Fechamento esternal tardio. Só quando necessário ou de rotina?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "E5vyIROa3z1fQkGypZ7y",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "KaWdZfRxjasUzJhLNCCO",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Como melhorar a CEC no neonato?",
                    "text": "",
                    "startTime": "11:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "Grp7ZpLL5sbcfYJM0t21",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Luiz Fernando Caneo ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "wHXMJkLIBPfEeVLpKozL",
                        "topic_name": "Como melhorar a CEC no neonato?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "KaWdZfRxjasUzJhLNCCO",
                        "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "OojLCAoWiLxJRLLnyyr4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Perguntas e Respostas",
                    "text": "",
                    "startTime": "12:20",
                    "duration": "10",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "Z4UFKI8maItqvQi8nBji",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Bandagem da AP em pacientes univentriculares",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "dSLHPzKH0oiuukq43W10",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Renato Samy Assad ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Bandagem da AP em pacientes univentriculares",
                        "activity_id": "wHXMJkLIBPfEeVLpKozL",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Z4UFKI8maItqvQi8nBji",
                        "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qkJGDzvH644syCSna4Fd",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "DBXFrf5DkWpT2TvjxMNx",
                    "activity_id": "wHXMJkLIBPfEeVLpKozL",
                    "date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                    "name": "Benefícios do implante preventivo do cateter de diálise peritoneal",
                    "text": "",
                    "startTime": "12:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "D2cTwd9pATkdowb98vkW",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685156400, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "Nadja Cecília de Castro Kraychete ",
                        "day_id": "DBXFrf5DkWpT2TvjxMNx",
                        "role_name": "Palestrante",
                        "topic_startTime": "12:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Segundo Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "wHXMJkLIBPfEeVLpKozL",
                        "topic_name": "Benefícios do implante preventivo do cateter de diálise peritoneal",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qkJGDzvH644syCSna4Fd",
                        "activity_name": " DCCVPED - MISCELÂNEA - QUESTÕES RELEVANTES NO MANEJO DE PACIENTE PEDIÁTRICO COM CARDIOPATIA CONGÊNITA",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "text": "",
            "materials": [],
            "id": "J6WUW98SpiJkWLybu9n5",
            "event_id": "qBicALVh9y4CdiTXYGrm",
            "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
            "name": "Primeiro Dia",
            "agenda": [],
            "activities": [
              {
                "id": "1Yz2lRh2VBRCgObqUfGJ",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "08:40",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "MylcOYoQFfJTDotsLSCv",
                    "activity_name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:40",
                    "member_name": "Amanda Arrais Bento de Souza",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "StlIQtMmDMg1YhG2x7hW",
                    "activity_name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:40",
                    "member_name": "Raphael da Rocha Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "BDWtE7JjYJJDP3UDHkFf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A experiência dos cursos de sutura desenvolvidos pela LACIC",
                    "text": "",
                    "startTime": "08:50",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "wWTa7TFo7Jj7G0Ab1e7r",
                        "topic_duration": "5",
                        "activity_name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:40",
                        "member_name": "Isabella Gomes Maggessi",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "BDWtE7JjYJJDP3UDHkFf",
                        "topic_name": "A experiência dos cursos de sutura desenvolvidos pela LACIC",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "LFXhYfw38cASKmuY92E2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "08:55",
                    "duration": "5",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "dvDtKkdB5DrcwYXFDZhJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "As experiências dos workshops práticos e das atividades de extensão da LACCV",
                    "text": "",
                    "startTime": "08:40",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "jFhi0hHkQ5SDbWHH0aAe",
                        "activity_name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                        "topic_duration": "5",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:40",
                        "member_name": "Leonardo Vitor Ortega ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                        "topic_name": "As experiências dos workshops práticos e das atividades de extensão da LACCV",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dvDtKkdB5DrcwYXFDZhJ",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kpr9CMMkVPmxOv1RXYxe",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A experiência do tripé Ensino, Pesquisa e Extensão no aprendizado dos ligantes LAC-TO",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
                        "topic_duration": "5",
                        "activity_name": "DBLACCV - FÓRUM DAS LIGAS - DBLACCV PELO BRASIL",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:40",
                        "member_name": "Marco Antonio de Sousa do Vale ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "A experiência do tripé Ensino, Pesquisa e Extensão no aprendizado dos ligantes LAC-TO",
                        "activity_id": "1Yz2lRh2VBRCgObqUfGJ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kpr9CMMkVPmxOv1RXYxe",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "1hUisNHre4I1I0Kymww6",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                "text": "<p><strong>Dinâmica: </strong>O mestre de cerimônias abrirá a sessão de Abertura do evento, chamando para o palco os Diretores que constam no Programa, para a sessão de fotos oficiais. Em seguida, o mestre de cerimônias convida o Dr. José Wanderley Neto, Coordenador da Comissão Local do 49º Congresso da SBCCV para seu discurso de boas-vindas (5 min). A seguir, o mestre de cerimônias convida o Presidente da SBCCV, para a Palavra do Presidente (10 min). Após, o Mestre de Cerimônias dá início às conferências de abertura, chamando os coordenadores da Mesa.</p><p>Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "11:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "8xaAN7yNUDDOVNkWcgFG",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "André Raimundo Franca Guimarães ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Pedro Rafael Salerno ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "pHopGlaMmGboS9s4ZJPk",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Vinicius José da Silva Nina",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "487mQwdaZGJfbJ8NbJ9n",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "João Carlos Ferreira Leal ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "ifgnNJhEmY84MFU1gQjF",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "José Wanderley Neto ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "vklFqYm25ki5o1mzphiQ",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Eduardo Keller Saadi ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "9bpCBQ85pG4g5h1I9TtZ",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Henrique Murad ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "ZnzxDdrZVoNZPLuaxGTG",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Luciano Cabral Albuquerque ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "Nci7AIXDEKQ27UR2Ryfu",
                    "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:00",
                    "member_name": "Carlos Manuel de Almeida Brandão ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Mesa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "dpaZAe2f6L9er6EpbvKN",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "jsxDcqXBYhETCnXekavI",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Palavra do Coordenador da Comissão Local do 49º Congresso da SBCCV",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "ifgnNJhEmY84MFU1gQjF",
                        "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "José Wanderley Neto ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "1hUisNHre4I1I0Kymww6",
                        "topic_name": "Palavra do Coordenador da Comissão Local do 49º Congresso da SBCCV",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jsxDcqXBYhETCnXekavI"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "y09vLpt2e1FceykMAhlC",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "1hUisNHre4I1I0Kymww6",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Palavra do Presidente",
                    "text": "",
                    "startTime": "11:05",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "487mQwdaZGJfbJ8NbJ9n",
                        "activity_name": "ABERTURA DO 49º CONGRESSO DA SBCCV",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "11:00",
                        "member_name": "João Carlos Ferreira Leal ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Palavra do Presidente",
                        "activity_id": "1hUisNHre4I1I0Kymww6",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "y09vLpt2e1FceykMAhlC",
                        "activity_location": "Auditório Principal",
                        "topic_duration": "10",
                        "topic_startTime": "11:05"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "2lJ7wTbZ7enV0as4kS7i",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Arena",
                "name": "ARENA",
                "text": "",
                "startTime": "10:15",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "3WPWLpxzQDDDw3fcwlmQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ARENA Braile Biomédica - Revisão de casos complexos e desenvolvimentos futuros com a plataforma de liveração rápida Alpha",
                    "text": "",
                    "startTime": "10:15",
                    "duration": "60",
                    "agenda": [
                      {
                        "member_id": "YSTjpav26KV1ydeC6v9p",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Gustavo Ieno Judas ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Moderador(a)",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "6QisZ6kM0eraJV2egjJa",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Braile Biomédica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "3WPWLpxzQDDDw3fcwlmQ"
                      },
                      {
                        "member_id": "487mQwdaZGJfbJ8NbJ9n",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "João Carlos Ferreira Leal ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Moderador(a)",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "6QisZ6kM0eraJV2egjJa",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "3WPWLpxzQDDDw3fcwlmQ",
                        "topic_name": "ARENA Braile Biomédica - Revisão de casos complexos e desenvolvimentos futuros com a plataforma de liveração rápida Alpha"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "IROdVgZNKbBfFfeDYejl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ARENA CORCYM - PERCEVAL™: da toracotomia tradicional à cirurgia minimamente invasiva - adequação ao perfil do paciente",
                    "text": "",
                    "startTime": "13:30",
                    "duration": "60",
                    "agenda": [
                      {
                        "member_id": "n2juAqlE737r3seFtUkI",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Vinicius Nicolau Woitowicz ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "topic_startTime": "13:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "IROdVgZNKbBfFfeDYejl",
                        "topic_name": "ARENA CORCYM - PERCEVAL™: da toracotomia tradicional à cirurgia minimamente invasiva - adequação ao perfil do paciente"
                      },
                      {
                        "member_id": "YSTjpav26KV1ydeC6v9p",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Gustavo Ieno Judas ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "topic_startTime": "13:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "IROdVgZNKbBfFfeDYejl",
                        "topic_name": "ARENA CORCYM - PERCEVAL™: da toracotomia tradicional à cirurgia minimamente invasiva - adequação ao perfil do paciente"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kRljCEoyClQkfXIg7uVJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ARENA Biomedical - Segurança e Assertividade na Extração de Eletrodos: melhor abordagem técnica e manejo de infecções.",
                    "text": "<p><strong>Data:&nbsp;</strong>26 de Maio de 2023&nbsp;</p><p><strong>Sala:&nbsp;</strong>ARENA 4</p><p><strong>Horário:&nbsp;</strong>14:45 às 15:45</p><p>&nbsp;</p><p><strong>Chairman e Debatedor:&nbsp;</strong>Prof. Dr. Roberto Costa&nbsp;</p><p><strong>Debatedores:</strong></p><p>Dr. José Jazbik&nbsp;</p><p>Dra. Tania Mara Strabelli&nbsp;</p><p><strong>Apresentadores de Casos:&nbsp;</strong></p><p>Dr. Carlos Eduardo Duarte&nbsp;</p><p>Dr. Wagner Nascimento&nbsp;</p><p>Dra. Silvia Leão Costa Baggio&nbsp;</p><p>Dra. Elizabeth Crevaleri</p>",
                    "startTime": "14:45",
                    "duration": "60",
                    "agenda": [
                      {
                        "member_id": "akUPKrpWe1E9PFpHU5Bm",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Roberto Costa ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Debatedor(a)",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "1aINPSVslZ6pt9f4Nwlt",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Elizabeth Sartori Crevelari ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "B1Gp5JPrjtIEP8dCrF2X",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Tânia Mara Strabelli ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Debatedor(a)",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "JQRfMjQb3Z3zbqdH03HC",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Carlos Eduardo Duarte",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "VbMNcKLLrk0hKCI602BU",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "João Carlos Jazbik ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Debatedor(a)",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "HjUKHP7CQv3XoTQrlttY",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Silvia Leão Costa Baggio",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      },
                      {
                        "member_id": "CKkNqopwpVvW55Fj6bm9",
                        "activity_name": "ARENA",
                        "topic_duration": "60",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:15",
                        "member_name": "Wagner Tadeu Jurevicius do Nascimento",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "2lJ7wTbZ7enV0as4kS7i",
                        "topic_name": "ARENA Biomedical",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kRljCEoyClQkfXIg7uVJ"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "5MDN5YUiIGYQuIA8N5sV",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
                    "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Fabrício Lara Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
                    "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Marco Antonio de Sousa do Vale ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "9kjLmsfPdhZ9uYCHKgii",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Congênita",
                    "text": "",
                    "startTime": "14:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "HiKwZGC9JxBw28x7X1ub",
                        "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Beatriz Helena S. Furlanetto ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                        "topic_name": "Congênita",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "9kjLmsfPdhZ9uYCHKgii",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "b58yCcZjE92d6RMaJAmd",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "MICS",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "VfFO3FTnWduNYdCq9nCY",
                        "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Robinson Poffo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                        "topic_name": "MICS",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "b58yCcZjE92d6RMaJAmd",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "eiIKeC9aBdWMlZYR5t3t",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Endovascular",
                    "text": "",
                    "startTime": "14:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "aNlwkmlC0g7HCk8XgXAS",
                        "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Alexandre Magno Macario Nunes Soares ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                        "topic_name": "Endovascular",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "eiIKeC9aBdWMlZYR5t3t",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "xShOJWIRbac9y1GYIEPk",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Aorta",
                    "text": "",
                    "startTime": "14:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7d0Yn3HYvs193QNeJ3ft",
                        "activity_name": "DBLACCV - SESSÃO INTEGRATIVA - SUBESPECIALIDADES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Rogério Ferrari Peron ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "5MDN5YUiIGYQuIA8N5sV",
                        "topic_name": "Aorta",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "xShOJWIRbac9y1GYIEPk",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "69jtXslHl9JTM43uzutg",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "ABRECCV - MESA REDONDA - PÓS GRADUAÇÃO E FELLOWSHIPS - ETAPAS VÁLIDAS NA FORMAÇÃO DO CIRURGIÃO CARDIOVASCULAR",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "09:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "DBdPuZ6vbbdhJCah62dE",
                    "activity_name": "ABRECCV - MESA REDONDA - PÓS GRADUAÇÃO E FELLOWSHIPS - ETAPAS VÁLIDAS NA FORMAÇÃO DO CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:30",
                    "member_name": "Luiz Carlos Lima da Silva Júnior",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "69jtXslHl9JTM43uzutg",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2"
                  },
                  {
                    "member_id": "1uk9yntz7n0s3s26AoOH",
                    "activity_name": "ABRECCV - MESA REDONDA - PÓS GRADUAÇÃO E FELLOWSHIPS - ETAPAS VÁLIDAS NA FORMAÇÃO DO CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:30",
                    "member_name": "Alvaro Monteiro Perazzo ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "activity_id": "69jtXslHl9JTM43uzutg",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 2"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "4OqRUtArJMFd0bEXUzb1",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "69jtXslHl9JTM43uzutg",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Pós graduação e Residência Médica em transplante cardíaco e assistência ventricular",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "TNegaNCo8I6SdabN45Gc",
                        "activity_name": "ABRECCV - MESA REDONDA - PÓS GRADUAÇÃO E FELLOWSHIPS - ETAPAS VÁLIDAS NA FORMAÇÃO DO CIRURGIÃO CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Samuel Padovani Steffen ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "69jtXslHl9JTM43uzutg",
                        "topic_name": "Pós graduação e Residência Médica em transplante cardíaco e assistência ventricular",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "4OqRUtArJMFd0bEXUzb1",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "cVm7zRiea9KiBEIDxd7l",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "69jtXslHl9JTM43uzutg",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Pós graduação e Residência Médica em cirurgia cardiovascular pediátrica e cardiopatias congênitas",
                    "text": "",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "LapyFJ6x4PKGq7qMfbdg",
                        "activity_name": "ABRECCV - MESA REDONDA - PÓS GRADUAÇÃO E FELLOWSHIPS - ETAPAS VÁLIDAS NA FORMAÇÃO DO CIRURGIÃO CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:30",
                        "member_name": "Leonardo Augusto Miana",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Pós graduação e Residência Médica em cirurgia cardiovascular pediátrica e cardiopatias congênitas",
                        "activity_id": "69jtXslHl9JTM43uzutg",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "cVm7zRiea9KiBEIDxd7l",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "7NphPXqnLxkMAJOhrYPI",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "ASSEMBLEIA GERAL SBCCV",
                "text": "<p><strong>Dinâmica : </strong>Atividade coordenada pela Meryt. Deve haver &nbsp;uma assistente de palco e apoio de recepção na plateia, para microfone. Audiovisual também deverá estar funcionando</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "18:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "QdYtpptczV1MnVb7UF6x",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "7NphPXqnLxkMAJOhrYPI",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Assembleia Geral SBCCV",
                    "text": "",
                    "startTime": "18:30",
                    "duration": "90",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "8lUpF8Bz7vVmfu3eEd9P",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - ASSEMBLEIA GERAL ",
                "text": "<p><strong>Dinâmica : </strong>Atividade coordenada pela Diretoria do Departamento. Deve haver apenas uma assistente de palco</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "17:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "ekBPU6UaprVi9qqKaBXH",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "8lUpF8Bz7vVmfu3eEd9P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ASSEMBLEIA GERAL ",
                    "text": "",
                    "startTime": "17:30",
                    "duration": "60",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "AdLU23NE8xFTqq2VgBnr",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "16:45",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                    "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Vinicius José da Silva Nina",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "AdLU23NE8xFTqq2VgBnr",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "pw7FmMZMBTtsbcRfAVBk",
                    "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "José Teles de Mendonça ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "AdLU23NE8xFTqq2VgBnr",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "213eBVEeY5DGHH6P0onf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "AdLU23NE8xFTqq2VgBnr",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Dilema da Medicina no Brasil: Medicina no SUS x Saúde Suplementar",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "16:45",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "SFNBoq7e9WXbhS4DRrSh",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Davi Freitas Tenório",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "topic_name": "Dilema da Medicina no Brasil: Medicina no SUS x Saúde Suplementar",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "213eBVEeY5DGHH6P0onf",
                        "topic_duration": "30",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "ifgnNJhEmY84MFU1gQjF",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "requireSchedule": false,
                        "requireConfirm": false,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "José Wanderley Neto ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Dilema da Medicina no Brasil: Medicina no SUS x Saúde Suplementar",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "213eBVEeY5DGHH6P0onf",
                        "topic_duration": "30",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "VbemlUiQZS2XiFQdu4NW",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Fernando Antonio Lucchese ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "topic_name": "Dilema da Medicina no Brasil: Medicina no SUS x Saúde Suplementar",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "213eBVEeY5DGHH6P0onf",
                        "topic_duration": "30",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "dRvjHqXtrjmtHLelYaUx",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "AdLU23NE8xFTqq2VgBnr",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Cirurgia Cardiovascular e as fronteiras do conhecimento",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "17:15",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "1uk9yntz7n0s3s26AoOH",
                        "topic_duration": "30",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Alvaro Monteiro Perazzo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "17:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "topic_name": "Cirurgia Cardiovascular e as fronteiras do conhecimento",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dRvjHqXtrjmtHLelYaUx",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "HpAQ9NQjmjwtFQlGbFXQ",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "topic_duration": "30",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Paulo Roberto Barbosa Evora ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "17:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "topic_name": "Cirurgia Cardiovascular e as fronteiras do conhecimento",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dRvjHqXtrjmtHLelYaUx",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "5yrGDXcl3mMyHZSJbuow",
                        "topic_duration": "30",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "José Honório de Almeida Palma Fonseca",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Cirurgia Cardiovascular e as fronteiras do conhecimento",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dRvjHqXtrjmtHLelYaUx",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kvY2qOo3R3w6jSd6Nczu",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "AdLU23NE8xFTqq2VgBnr",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Futuro da Cirurgia Cardiovascular frente aos avanços da tecnologia / Future of Cardiovascular Surgery in the face of technological advances",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "17:45",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "topic_duration": "30",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Magaly Arrais dos Santos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "17:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "topic_name": "Futuro da Cirurgia Cardiovascular frente aos avanços da tecnologia / Future of Cardiovascular Surgery in the face of technological advances",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kvY2qOo3R3w6jSd6Nczu",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "topic_duration": "30",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Pedro Rafael Salerno ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "17:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "topic_name": "Futuro da Cirurgia Cardiovascular frente aos avanços da tecnologia / Future of Cardiovascular Surgery in the face of technological advances",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kvY2qOo3R3w6jSd6Nczu",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "D95i2ch1buGrZQBouOuA",
                        "activity_name": "ACADEMIA - DEBATES - MEDICINA E HUMANISMO FRENTE À TECNOLOGIA E AO MERCANTILISMO",
                        "topic_duration": "30",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Manuel J. Antunes",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "AdLU23NE8xFTqq2VgBnr",
                        "topic_name": "Futuro da Cirurgia Cardiovascular frente aos avanços da tecnologia / Future of Cardiovascular Surgery in the face of technological advances",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kvY2qOo3R3w6jSd6Nczu",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "BUgeoY8Dn8zECrvSPpKp",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Área de Exposição",
                "name": "INTERVALO",
                "text": "",
                "startTime": "10:45",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "mKCr0Vk4P1CvlCtrDq16",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "BUgeoY8Dn8zECrvSPpKp",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Visita aos Expositores",
                    "text": "",
                    "startTime": "10:45",
                    "duration": "15",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "Bft4pBFjp7Be8LRc9dix",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "oNlbl9hoqO4Ywxa9vCaG",
                    "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Maikon Lucian Madeira Quarti",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2"
                  },
                  {
                    "member_id": "p5qCiPwfNvMKW046LzEC",
                    "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Leila Nogueira Ferreira de Barros",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 2"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "48N36It1j0v3kuz6HBfo",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Desafios na implantação do novo currículo: a visão da SBCCV",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pHopGlaMmGboS9s4ZJPk",
                        "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Desafios na implantação do novo currículo: a visão da SBCCV",
                        "activity_id": "Bft4pBFjp7Be8LRc9dix",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "48N36It1j0v3kuz6HBfo",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "7jm7zzUvFvROKPvwZ2TU",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Perspectivas futuras e o aperfeiçoamento para o novo currículo",
                    "text": "",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                        "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Pedro Rafael Salerno ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Bft4pBFjp7Be8LRc9dix",
                        "topic_name": "Perspectivas futuras e o aperfeiçoamento para o novo currículo",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "7jm7zzUvFvROKPvwZ2TU",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "XxZi54DWBC7mAAKqBGvk",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Desafios na implantação do novo currículo: a visão do Chefe de Serviço",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "BTlpXRTvn56uWDHODHh2",
                        "topic_duration": "15",
                        "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Fabio Biscegli Jatene ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "Bft4pBFjp7Be8LRc9dix",
                        "topic_name": "Desafios na implantação do novo currículo: a visão do Chefe de Serviço",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "XxZi54DWBC7mAAKqBGvk",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "mUbUmLQSK3GqjRzgv2s3",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Bft4pBFjp7Be8LRc9dix",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Desafios na implantação do novo currículo: a visão da primeira turma",
                    "text": "",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "SFNBoq7e9WXbhS4DRrSh",
                        "topic_duration": "15",
                        "activity_name": "ABRECCV - MESA REDONDA - LIÇÕES APRENDIDAS COM A FORMATURA DA PRIMEIRA TURMA DO NOVO CURRÍCULO",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Davi Freitas Tenório",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Desafios na implantação do novo currículo: a visão da primeira turma",
                        "activity_id": "Bft4pBFjp7Be8LRc9dix",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "mUbUmLQSK3GqjRzgv2s3",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "F7FpBlz1xymaxK9OzpvL",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "KjpMuLGHX3c1svkrsP74",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "member_name": "Andrey José Oliveira Monteiro ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "activity_startTime": "14:00",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "tzJCMWiuMCTkL2QuBrP8",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "José da Silva Leitão Neto ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "CueH6K5TXWHmDywvXCck",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Manejo pós-operatório - Visão do intensivista",
                    "text": "",
                    "startTime": "14:40",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "UJacaX2kzPO0yjOYfOz9",
                        "topic_duration": "20",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carolina Campos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Conferencista",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "uYOH6vwplH1OSKByONkf",
                        "activity_id": "F7FpBlz1xymaxK9OzpvL",
                        "topic_name": "Manejo pós-operatório - Visão do intensivista",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "CueH6K5TXWHmDywvXCck",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "KbVKZfYKi2gznhKAfuPa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "15:40",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "UdONzNjVOHF9uaIN6GMt",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Segundo estágio híbrido. Quando indicar Norwood-Shunt? Quando indicar Norwood-Glenn? Abordagem das artérias pulmonares",
                    "text": "",
                    "startTime": "15:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "LapyFJ6x4PKGq7qMfbdg",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Leonardo Augusto Miana",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "F7FpBlz1xymaxK9OzpvL",
                        "topic_name": "Segundo estágio híbrido. Quando indicar Norwood-Shunt? Quando indicar Norwood-Glenn? Abordagem das artérias pulmonares",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "UdONzNjVOHF9uaIN6GMt",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "WACidfX7rgpKyNZ94PoG",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Condução da CEC na Cirurgia de Norwood ",
                    "text": "",
                    "startTime": "14:20",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "Q2gVHf5GxvfJb7T0N0Y1",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Gilberto de Oliveira Scuciato",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "14:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "activity_id": "F7FpBlz1xymaxK9OzpvL",
                        "topic_name": "Condução da CEC na Cirurgia de Norwood ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "WACidfX7rgpKyNZ94PoG",
                        "activity_location": "Auditório 3",
                        "role_name": "Conferencista",
                        "role_id": "uYOH6vwplH1OSKByONkf"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "mTPJE3HTi7OvcMH1Fbkl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "O papel e a condução da ECMO em SHVE",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "MQUbWXhvWDkLgavimnm2",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Juliana Pacheco",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Conferencista",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "uYOH6vwplH1OSKByONkf",
                        "activity_id": "F7FpBlz1xymaxK9OzpvL",
                        "topic_name": "O papel e a condução da ECMO em SHVE",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "mTPJE3HTi7OvcMH1Fbkl",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "r12hDyjPIswO0Di5vBqP",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "F7FpBlz1xymaxK9OzpvL",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Manejo pré operatório: importância do manejo anestésico",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "7CicIdgq5k2b07bOJBeX",
                        "topic_duration": "20",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - SESSÃO DE MINI CONFERÊNCIAS",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carolina Rizzoni Silveira",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "topic_name": "Manejo pré operatório: importância do manejo anestésico",
                        "activity_id": "F7FpBlz1xymaxK9OzpvL",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "r12hDyjPIswO0Di5vBqP",
                        "role_name": "Conferencista",
                        "role_id": "uYOH6vwplH1OSKByONkf",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "FVtvGEggbhcw5y8R59Ec",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "08:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "KGboPJaP8ub7mjron2Qe",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:15",
                    "member_name": "Fernando Antoniali ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "uk3OMbPvTpFbkwnLy5bI",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:15",
                    "member_name": "Valdester Cavalcante Pinto Júnior ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "4ePsY1mW9iMjFJOlybKW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Manejo pré operatório",
                    "text": "",
                    "startTime": "08:35",
                    "duration": "10",
                    "agenda": [
                      {
                        "member_id": "UJacaX2kzPO0yjOYfOz9",
                        "topic_duration": "10",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:15",
                        "member_name": "Carolina Campos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "FVtvGEggbhcw5y8R59Ec",
                        "topic_name": "Manejo pré operatório",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "4ePsY1mW9iMjFJOlybKW",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "C71aG2RmGrCtgVOJuFnY",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Cirurgia de Norwood-Sano - Quando indicar? Quando contra indicar?",
                    "text": "",
                    "startTime": "09:05",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "RMgYjWDJG31XBgtBOMP2",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:15",
                        "member_name": "José Pedro da Silva ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "FVtvGEggbhcw5y8R59Ec",
                        "topic_name": "Cirurgia de Norwood-Sano - Quando indicar? Quando contra indicar?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "C71aG2RmGrCtgVOJuFnY",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "JT3fSvPkb6ZxP76bSDCF",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Aspectos anatômicos e epidemiológicos",
                    "text": "",
                    "startTime": "08:15",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "R8eeBXUPiiEQFdugOJr5",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:15",
                        "member_name": "Ivan Romero Rivera",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "FVtvGEggbhcw5y8R59Ec",
                        "topic_name": "Aspectos anatômicos e epidemiológicos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "JT3fSvPkb6ZxP76bSDCF",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "PlS4lmnaH1kgtDXvWzCG",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Abordagem híbrida. Quando indicar?  Desafios (CIA restritiva, CoAo)",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "ojVPBcxW6WCnYtTHpsXE",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:15",
                        "member_name": "José Cícero Stocco Guilhen ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "FVtvGEggbhcw5y8R59Ec",
                        "topic_name": "Abordagem híbrida. Quando indicar?  Desafios (CIA restritiva, CoAo)",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "PlS4lmnaH1kgtDXvWzCG",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "iqYFzihkSXSHkhesrTWp",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "09:45",
                    "duration": "45",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "sdHcrEIRheRciriMmmQy",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "FVtvGEggbhcw5y8R59Ec",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Cirurgia de Norwood clássico - Quando (ou não) indicar? Como eu faço? Dicas e truques",
                    "text": "",
                    "startTime": "09:25",
                    "duration": "20",
                    "agenda": [
                      {
                        "member_id": "uk3OMbPvTpFbkwnLy5bI",
                        "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - MESA REDONDA - SHVE",
                        "topic_duration": "20",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:15",
                        "member_name": "Valdester Cavalcante Pinto Júnior ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:25",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "FVtvGEggbhcw5y8R59Ec",
                        "topic_name": "Cirurgia de Norwood clássico - Quando (ou não) indicar? Como eu faço? Dicas e truques",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "sdHcrEIRheRciriMmmQy",
                        "activity_location": "Auditório 3"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "HwOan31dduaq3HmfqJil",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - ABERTURA",
                "text": "<p>Dr. Pedro Salerno apenas dará as boas-vindas a todos.&nbsp;</p>",
                "startTime": "08:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZSAm1sNI0J0iTAAEqc9L",
                    "activity_name": "DCCVPED - ABERTURA",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:00",
                    "member_name": "Pedro Rafael Salerno ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "HwOan31dduaq3HmfqJil",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 3"
                  },
                  {
                    "member_id": "1GHWyumTeOxSvRrkVHTV",
                    "activity_name": "DCCVPED - ABERTURA",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:00",
                    "member_name": "Sândra Maria",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Acadêmico",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "iqUmxwE8DOpSaVkuO9nQ",
                    "activity_id": "HwOan31dduaq3HmfqJil",
                    "event_name": "49º Congresso da SBCCV • 2023"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "3smRLpHJh955nlJ0eCRC",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "HwOan31dduaq3HmfqJil",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ABERTURA",
                    "text": "",
                    "startTime": "08:00",
                    "duration": "10",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "N9ewXqlodyjmAjurNH2X",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. <strong>A dinâmica será como debate, sem apresentação de slides, apenas conversa entre os palestrantes</strong></p><p>Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "15:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "NsfYLwC5wmSrRbSVh17F",
                    "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "15:00",
                    "member_name": "Antonio Carlos de Almeida Barbosa Filho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "StlIQtMmDMg1YhG2x7hW",
                    "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "15:00",
                    "member_name": "Raphael da Rocha Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "15:00",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "INlWeJ4883gZdzDWt9gv",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A influência do mentor nas decisões acadêmicas e profissionais ",
                    "text": "",
                    "startTime": "15:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "LHp66lMTiqQ3ZbPXi51K",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "15:00",
                        "member_name": "Gabriel Rodrigues Bittencourt ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "A influência do mentor nas decisões acadêmicas e profissionais ",
                        "activity_id": "N9ewXqlodyjmAjurNH2X",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "INlWeJ4883gZdzDWt9gv",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "OF8lS49yGrArHQU69ER4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Como encontrar um mentor / How to find a mentor",
                    "text": "",
                    "startTime": "15:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "AfGK5WdgVzoI0ZMUrrTA",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "15:00",
                        "member_name": "Emily Farkas",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "N9ewXqlodyjmAjurNH2X",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "OF8lS49yGrArHQU69ER4",
                        "topic_name": "Como encontrar um mentor / How to find a mentor",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "U90zSLCkMhx5GlX9TPNZ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "O papel do mentor para o acadêmico",
                    "text": "",
                    "startTime": "15:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "keFvoyoOACgEM8bxAcmx",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "15:00",
                        "member_name": "Henrique Madureira da Rocha Coutinho ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "O papel do mentor para o acadêmico",
                        "activity_id": "N9ewXqlodyjmAjurNH2X",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "U90zSLCkMhx5GlX9TPNZ",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "rZcCXgN5FPEBo0ASfyhL",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "N9ewXqlodyjmAjurNH2X",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A importância das Ligas na formação acadêmica",
                    "text": "",
                    "startTime": "15:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ifgnNJhEmY84MFU1gQjF",
                        "activity_name": "DBLACCV - MESA REDONDA I - INFLUÊNCIAS NA FORMAÇÃO DO JOVEM CIRURGIÃO CARDIOVASCULAR. OS CAMINHOS A SEREM SEGUIDOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "15:00",
                        "member_name": "José Wanderley Neto ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "N9ewXqlodyjmAjurNH2X",
                        "topic_name": "A importância das Ligas na formação acadêmica",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "rZcCXgN5FPEBo0ASfyhL",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "OGV9g8BuHG7q8vYgKYVz",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Área de Exposição",
                "name": "INTERVALO",
                "text": "",
                "startTime": "16:00",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "TLiYcRgx4fzxmUaZ0YLT",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "OGV9g8BuHG7q8vYgKYVz",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Visita aos Expositores",
                    "text": "",
                    "startTime": "16:00",
                    "duration": "45",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "PomHXP5MvSMGhcvxQmV7",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 3",
                "name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p><p>Não há necessidade de apresentação de slides pelos palestrantes. Será um debate, com a mediação dos coordenadores (perguntas)</p>",
                "startTime": "16:45",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "7wgRccFQiSVeGruP4z8c",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Fábio Binhara Navarro ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "role_name": "Debatedor(a)"
                  },
                  {
                    "member_id": "Grp7ZpLL5sbcfYJM0t21",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Luiz Fernando Caneo ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "role_name": "Debatedor(a)"
                  },
                  {
                    "member_id": "9Wur5mlBxqRBsiC0ZPdP",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Luciana Fonseca da Silva",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "role_name": "Debatedor(a)"
                  },
                  {
                    "member_id": "HiKwZGC9JxBw28x7X1ub",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Beatriz Helena S. Furlanetto ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "akXbIW6V3Q1UHZQzE0BF",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "role_name": "Debatedor(a)"
                  },
                  {
                    "member_id": "LapyFJ6x4PKGq7qMfbdg",
                    "activity_name": "DCCVPED - SÍNDROME DE HIPOPLASIA DO VENTRÍCULO ESQUERDO DE A - Z - COLÓQUIO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Leonardo Augusto Miana",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 3",
                    "role_name": "Coordenador(a)"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "LmqALgCcp5G28eGYKioX",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Situações especiais - Insuficiência da valva AV e recoarctação de aorta",
                    "text": "",
                    "startTime": "17:05",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "k5hZ9pN29nqyXA32Bazr",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Fontan na SHVE - peculiaridades",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "20",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "ujRzJUEWkNTYz4BcITFn",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "PomHXP5MvSMGhcvxQmV7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Disfunção de ventrículo - ECMO - Tx",
                    "text": "",
                    "startTime": "17:25",
                    "duration": "5",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "Q8sbCoHkK33yOMJ5YPOU",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "ÁREA DE EXPOSIÇÃO ",
                "name": "DBLACCV - SESSÃO DE PÔSTER I",
                "text": "",
                "startTime": "10:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ThV5wKk60ERXMcvhChfj",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "10:30",
                    "member_name": "Sérgio Francisco dos Santos Júnior ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                    "activity_location": "ÁREA DE EXPOSIÇÃO "
                  },
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "requireSchedule": false,
                    "level": "a",
                    "acceptInvite": false,
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "10:30",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                    "activity_location": "ÁREA DE EXPOSIÇÃO "
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "0vAelNQvXsFg6zSr7bVi",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "P01 - Impacto da fisioterapia na qualidade da alta na UTI pela escala de Johns Hopkins nos pacientes de pós-operatório cirúrgia cardiaca ",
                    "text": "<p><i><strong>Autores: </strong>Kátia Solange Sachicago de Assuilo Ortet, Isabel Salvador, Mamene Rogerio, Landu Caxala, Valdano Manuel, Elizabeth Paz&nbsp;</i></p><p><br><i><strong>Instituição: </strong>Complexo Hospitalar de Doenças Cardio Pulmoares Cardeal Dom Alexandre do Nascimento Luanda -Angola&nbsp;</i></p>",
                    "startTime": "10:30",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "I8KcKPnyooy3IqsCXRqt",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "topic_duration": "5",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Kátia Solange Sachicago de Assuilo Ortet",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "topic_name": "P01 - Impacto da fisioterapia na qualidade da alta na UTI pela escala de Johns Hopkins nos pacientes de pós-operatório cirúrgia cardiaca ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "0vAelNQvXsFg6zSr7bVi"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "8S3q37wvwRHGOzZ1dd7S",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO04 - Correção de estenose aórtica severa e valva aórtica bicúspide com prótese de rápida implantação, confecção de hemiarco devido doença aneurismática e revascularização do miocárdico após operação de Tirone David ",
                    "text": "<p><i>Autores: Diego Maia Martins, Stevan Krieger Martins, Frederico Carlos Cordeiro de Mendonça, Alvaro Daniel Ortuño Justiniano, Jorge Henrique Yoscimoto Koroishi, Igor Gomes Cristo&nbsp;</i></p><p><i>Instituição: Hospital do Coração - HCor (SP)&nbsp;</i></p>",
                    "startTime": "10:45",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "s3183n94ktnCfjlUXRSu",
                        "topic_duration": "5",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Diego Maia Martins ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO04 - Correção de estenose aórtica severa e valva aórtica bicúspide com prótese de rápida implantação, confecção de hemiarco devido doença aneurismática e revascularização do miocárdico após operação de Tirone David ",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "8S3q37wvwRHGOzZ1dd7S",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "9YAmFu2oV6BC7n4UHnB4",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO03 - Tratamento transcateter da tricúspide: a valva esquecida",
                    "text": "",
                    "startTime": "10:40",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "MylcOYoQFfJTDotsLSCv",
                        "topic_duration": "5",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Amanda Arrais Bento de Souza",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO03 - Tratamento transcateter da tricúspide: a valva esquecida",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "9YAmFu2oV6BC7n4UHnB4",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "GJUCfsKGNuCXc9LBXW7l",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO05 - Análise epidemiológica das cirurgias de plástica e/ou troca valvar no Brasil entre 2013 e 2022 ",
                    "text": "",
                    "startTime": "10:50",
                    "duration": "5",
                    "agenda": [
                      {
                        "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
                        "topic_duration": "5",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "acceptInvite": false,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Marco Antonio de Sousa do Vale ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO05 - Análise epidemiológica das cirurgias de plástica e/ou troca valvar no Brasil entre 2013 e 2022 ",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "GJUCfsKGNuCXc9LBXW7l",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "JZ9PU9VK39A0ckt59F5u",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO08 - Tratamento percutâneo de pseudoaneurisma de ventrículo esquerdo após cirurgia valvar: relato de caso ",
                    "text": "",
                    "startTime": "11:05",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "7iqUcVq6NtGO2UI0Mbwm",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Bruno Andrade Mello Teixeira de Oliveira",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "11:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO08 - Tratamento percutâneo de pseudoaneurisma de ventrículo esquerdo após cirurgia valvar: relato de caso ",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "JZ9PU9VK39A0ckt59F5u",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "b3G8rDDmQOefHjhvoJGc",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO09 - Hematoma de septo interventricular como complicação pós cirúrgica na correção de comunicação interventricular: relato de dois casos",
                    "text": "<p>Autores: Arthur Línniker Lopes de Oliveira, Catarina Silva de Souza Diógenes Paiva, Isabelle Catarine Reis Lima, Edson Duarte Lira Filho, Mayra Moreira, Raimundo Francisco de Amorim Junior&nbsp;<br>Instituição: Universidade Potiguar (RN)</p>",
                    "startTime": "11:10",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "RUs6p4DmC4SgSyMCdVJx",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "acceptInvite": false,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Arthu Línniker Lopes de Oliveira ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "11:10",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "topic_name": "PO09 - Hematoma de septo interventricular como complicação pós cirúrgica na correção de comunicação interventricular: relato de dois casos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "b3G8rDDmQOefHjhvoJGc",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "fFORzZkYj1izaWEYIKEt",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO06 - Canulação de ventrículo esquerdo em paciente portador de dissecção de aorta Stanford a aguda ",
                    "text": "<figure class=\"table\"><table><tbody><tr><td>Autores: Matheus da Silva Passos, Lenny Gabriela Giese Urresti, Pedro Paulo Martins de Oliveira, Renata Muller Couto, Marcelo Vial Felix de Sousa, Pedro Henrique Ramos Lopes&nbsp;<br>Instituição: Faculdade de Ciências Médicas - UNICAMP (SP)&nbsp;</td></tr></tbody></table></figure>",
                    "startTime": "10:55",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "DuKaaPi6jJnw7gKQrnIH",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Matheus da Silva Passos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:55",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "topic_name": "PO06 - Canulação de ventrículo esquerdo em paciente portador de dissecção de aorta Stanford a aguda ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fFORzZkYj1izaWEYIKEt",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "oUhSskPE9zLYyFf0Kvun",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO07 - Correção endovascular de fístula aorto-átrio direito ",
                    "text": "",
                    "startTime": "11:00",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "DuKaaPi6jJnw7gKQrnIH",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Matheus da Silva Passos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "11:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "topic_name": "PO07 - Correção endovascular de fístula aorto-átrio direito ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "oUhSskPE9zLYyFf0Kvun",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO "
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pnFW1WfVXs0O6mIdnhP8",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO02 - Internações e Morbidade por Doença Reumática Crônica do Coração em Alagoas (2012-2022)",
                    "text": "<p><i><strong>Autores: </strong>Laissa Inácio da Silva, Adson Yvens de Holanda Agostinho, Helen Rodrigues da Rocha, Tatiana Farias de Oliveira, Bruna Karolayne Sampaio, Amanda Karine Barros Ferreira&nbsp;</i><br>&nbsp;</p><p><i><strong>Instituição:</strong> Universidade Federal de Alagoas campus Arapiraca (CE)&nbsp;</i></p>",
                    "startTime": "10:35",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "6u7K7AS8Ao8s7DKpa8fv",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:30",
                        "member_name": "Laissa Inacio da Silva",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "10:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "Q8sbCoHkK33yOMJ5YPOU",
                        "topic_name": "PO02 - Internações e Morbidade por Doença Reumática Crônica do Coração em Alagoas (2012-2022)",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "pnFW1WfVXs0O6mIdnhP8",
                        "activity_name": "DBLACCV - SESSÃO DE PÔSTER I",
                        "activity_location": "ÁREA DE EXPOSIÇÃO ",
                        "topic_duration": "05"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "SXK9lA5tIJ4b0cJjLlbu",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Área de Exposição",
                "name": "ALMOÇO",
                "text": "",
                "startTime": "12:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "t574Jw5fpHASjmMUQ8bk",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "SXK9lA5tIJ4b0cJjLlbu",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Almoço",
                    "text": "",
                    "startTime": "12:30",
                    "duration": "90",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "Sqypfm1WsJHBglUggNea",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - ENCERRAMENTO",
                "text": "",
                "startTime": "18:15",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "acceptInvite": false,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Marco Antonio de Sousa do Vale ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023"
                  },
                  {
                    "member_id": "wWTa7TFo7Jj7G0Ab1e7r",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Isabella Gomes Maggessi",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "gAPfW2GOCBtLPWJLwYt5",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Eduarda Cabral Braga da Costa",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "MylcOYoQFfJTDotsLSCv",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Amanda Arrais Bento de Souza",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Fabrício Lara Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "StlIQtMmDMg1YhG2x7hW",
                    "activity_name": "DBLACCV - ENCERRAMENTO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "18:15",
                    "member_name": "Raphael da Rocha Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "BxlagcSuy55vTwWqHceo",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Encerramento 12º Congresso Acadêmico de Cirurgia Cardiovascular",
                    "text": "",
                    "startTime": "18:25",
                    "duration": "10",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "FWmr7st4QNVttHgKfp5b",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "Sqypfm1WsJHBglUggNea",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Votação da Diretoria 2023/2024",
                    "text": "",
                    "startTime": "18:15",
                    "duration": "10",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "UTcy9YZNH9mzXrwoxWoc",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "MESA REDONDA II - VÁLVULA",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para &nbsp;perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "16:45",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "UFJ3Ac1G2vumQDKpdZpH",
                    "activity_name": "MESA REDONDA II - VÁLVULA",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Mário Ricardo Amar ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "NAPjWcx02AeX9WhGu7cW",
                    "activity_name": "MESA REDONDA II - VÁLVULA",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Luciano Rapold Souza ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "Jktlqj9ZgGor48lCOaqh",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Quando e como realizar a técnica de Commando na endocardite infecciosa?",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "Nci7AIXDEKQ27UR2Ryfu",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Carlos Manuel de Almeida Brandão ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Quando e como realizar a técnica de Commando na endocardite infecciosa?",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Jktlqj9ZgGor48lCOaqh",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "K8yEdP5oRRPtPt60c1ni",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Estratégia cirúrgica para a troca valvar na calcificação do anel mitral",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "FjybEQe6bu0giHrR1tNN",
                        "topic_duration": "15",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Fernando Ribeiro Moraes Neto ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Estratégia cirúrgica para a troca valvar na calcificação do anel mitral",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "K8yEdP5oRRPtPt60c1ni",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "PokkAPV7uFjgfRBxmZdM",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "18:15",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "eupFujkni7qVPYfXQHfa",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Quando intervir na endocardite infecciosa com comprometimento neurológico?",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "4l3989WUqEkyDScf47UK",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Marcela da Cunha Sales ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "topic_name": "Quando intervir na endocardite infecciosa com comprometimento neurológico?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "eupFujkni7qVPYfXQHfa",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "fE8EMpNwhujPfS6azqPZ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Há espaço para válvula mecânica em posição aórtica em pacientes na faixa etária dos 50 anos aos 65 anos?",
                    "text": "",
                    "startTime": "18:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "3bBMe1tSxrHWLxgifWCY",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Tatiana Maia Jorge Ulhôa Barbosa ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "18:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "topic_name": "Há espaço para válvula mecânica em posição aórtica em pacientes na faixa etária dos 50 anos aos 65 anos?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fE8EMpNwhujPfS6azqPZ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "g0Q3K0WP0IKgtdMJamiT",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Quando indicar e qual a escolha da técnica para o alargamento do anel valvar aórtico?",
                    "text": "",
                    "startTime": "17:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ZebI3mSmhsWZHYTKRcsw",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Renato Abdala Karam Kalil ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "topic_name": "Quando indicar e qual a escolha da técnica para o alargamento do anel valvar aórtico?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "g0Q3K0WP0IKgtdMJamiT",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "uckWByZU2kNWpauoWAbs",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Há espaço para o uso de NOAC's após o implante de bioprótese com fibrilação atrial?",
                    "text": "",
                    "startTime": "17:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "5rEOtK64Rnx1EuO4Bi0l",
                        "activity_name": "MESA REDONDA II - VÁLVULA",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Diana Patrícia Lamprea",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "UTcy9YZNH9mzXrwoxWoc",
                        "topic_name": "Há espaço para o uso de NOAC's após o implante de bioprótese com fibrilação atrial?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "uckWByZU2kNWpauoWAbs",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "UjFDFzBcBWPFHJ67yUhS",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "ABRECCV - ENCERRAMENTO E ASSEMBLEIA GERAL DA ABRECCV",
                "text": "<p><strong>Dinâmica: </strong>Essa dinâmica é organizada pelo próprio Departamento. Não há a necessidade de recepcionista de apoio</p>",
                "startTime": "10:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "C8EXe2oAuT64PWghHqsQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "UjFDFzBcBWPFHJ67yUhS",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "ENCERRAMENTO E ASSEMBLEIA GERAL DA ABRECCV",
                    "text": "",
                    "startTime": "10:30",
                    "duration": "15",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "doUa8KQ0uG5qykJywnJ4",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "CONFERÊNCIAS DE ATUALIZAÇÃO/ UP TO DATE LECTURES",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e conferencistas ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas.</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong></p>",
                "startTime": "11:20",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ZebI3mSmhsWZHYTKRcsw",
                    "activity_name": "CONFERÊNCIAS DE ATUALIZAÇÃO/ UP TO DATE LECTURES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:20",
                    "member_name": "Renato Abdala Karam Kalil ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "doUa8KQ0uG5qykJywnJ4",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "pw7FmMZMBTtsbcRfAVBk",
                    "activity_name": "CONFERÊNCIAS DE ATUALIZAÇÃO/ UP TO DATE LECTURES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "11:20",
                    "member_name": "José Teles de Mendonça ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "doUa8KQ0uG5qykJywnJ4",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "0IHMb2a4VM7lPQRAAbpo",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "doUa8KQ0uG5qykJywnJ4",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "FET na dissecção aguda da aorta / FET in acute aortic dissection",
                    "text": "",
                    "startTime": "11:50",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "5RjK5uDeRbIyXkGQpq9m",
                        "activity_name": "CONFERÊNCIAS DE ATUALIZAÇÃO/ UP TO DATE LECTURES",
                        "requireSchedule": false,
                        "requireConfirm": false,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "11:20",
                        "member_name": "Roberto Di Bartolomeo",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Conferencista",
                        "topic_startTime": "11:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "uYOH6vwplH1OSKByONkf",
                        "activity_id": "doUa8KQ0uG5qykJywnJ4",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "0IHMb2a4VM7lPQRAAbpo",
                        "topic_name": "FET na dissecção aguda da aorta / FET in acute aortic dissection",
                        "topic_duration": "30",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "hvhmJxHrtaUqPEZUjB6k",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "doUa8KQ0uG5qykJywnJ4",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Insuficiência tricúspide: opções de tratamento no momento atual / Tricuspid regurgitation: current treatment options",
                    "text": "",
                    "startTime": "11:20",
                    "duration": "30",
                    "agenda": [
                      {
                        "member_id": "D9OFMMa4b6zhRZ90JGDg",
                        "topic_duration": "30",
                        "activity_name": "CONFERÊNCIAS DE ATUALIZAÇÃO/ UP TO DATE LECTURES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "11:20",
                        "member_name": "Giuseppe Bruschi",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "11:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "activity_id": "doUa8KQ0uG5qykJywnJ4",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "hvhmJxHrtaUqPEZUjB6k",
                        "role_name": "Conferencista",
                        "role_id": "uYOH6vwplH1OSKByONkf",
                        "topic_name": "Insuficiência tricúspide: opções de tratamento no momento atual / Tricuspid regurgitation: current treatment options",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "jRhpMKdVR7Y8owgnoviY",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p><p><i><strong>atenção para o detalhe de que o palestrante tem 30 minutos de palestra e em seguida os debatedores têm 10 min para falarem sobre o tema.</strong></i></p><figure class=\"table\"><table><tbody><tr><td colspan=\"3\">DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO</td></tr><tr><td colspan=\"3\">Coordenadores:Enio Buffolo (SP), João Carlos F. Leal (SP)</td></tr><tr><td rowspan=\"9\">14h-16h</td><td rowspan=\"2\">14h-14h30</td><td>Valores fundamentais da humanidade: o que os pacientes me ensinaram</td></tr><tr><td>Palestrante:Protásio Lemos da Luz (SP)</td></tr><tr><td>14h30-14h40</td><td>Debatedores: Laio Caju Wanderley (AL), Noedir Stolf (SP)</td></tr><tr><td rowspan=\"2\">14h40-15h10</td><td>Ensino da cirurgia cardiovascular para diferentes gerações</td></tr><tr><td>Palestrante:Fabio B. Jatene (SP)</td></tr><tr><td>15h10-15h20</td><td>Debatedores: Ricardo de C. Lima (PE),&nbsp;Anderson S. Terrazas (AM)</td></tr><tr><td rowspan=\"2\">15h20-15h50</td><td>Contribuição da Cirurgia Cardiovascular ao desenvolvimento da Cardiologia / Contribution of Cardiovascular Surgery to the development of Cardiology</td></tr><tr><td>Palestrante:Tomas Salerno (EUA)</td></tr><tr><td>15h50-16h</td><td>Debatedores: Henrique Murad (RJ), Marcela C. Sales (RS)</td></tr></tbody></table></figure>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "KUrfspRDNH3y1f5UxEXv",
                    "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Enio Buffolo ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "jRhpMKdVR7Y8owgnoviY",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "487mQwdaZGJfbJ8NbJ9n",
                    "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "João Carlos Ferreira Leal ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "jRhpMKdVR7Y8owgnoviY",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "B8nCkdpeuYB5GhVBPAcL",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "jRhpMKdVR7Y8owgnoviY",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Valores fundamentais da humanidade: o que os pacientes me ensinaram",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "14:00",
                    "duration": "40",
                    "agenda": [
                      {
                        "member_id": "0HKGwQwroXpkyJLzp9Sh",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "topic_duration": "40",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Laio Caju Wanderley",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Debatedor(a)",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "topic_name": "Valores fundamentais da humanidade: o que os pacientes me ensinaram",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "B8nCkdpeuYB5GhVBPAcL",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "0qhPHbRIIKFp5Na5NXvN",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "topic_duration": "40",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Noedir Antonio Groppo Stolf ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Debatedor(a)",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "topic_name": "Valores fundamentais da humanidade: o que os pacientes me ensinaram",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "B8nCkdpeuYB5GhVBPAcL",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "av5zEU5opRhtGuSuvcda",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Protásio Lemos da Luz",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Valores fundamentais da humanidade: o que os pacientes me ensinaram",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "B8nCkdpeuYB5GhVBPAcL",
                        "topic_duration": "40",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "DOJgqwmYMKxxPOARvoP6",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "jRhpMKdVR7Y8owgnoviY",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Ensino da cirurgia cardiovascular para diferentes gerações",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "14:40",
                    "duration": "40",
                    "agenda": [
                      {
                        "member_id": "momWB9r97qBCF7ipcNZ0",
                        "topic_duration": "40",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Anderson da Silva Terrazas ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "topic_name": "Ensino da cirurgia cardiovascular para diferentes gerações",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "DOJgqwmYMKxxPOARvoP6",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "BTlpXRTvn56uWDHODHh2",
                        "topic_duration": "40",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Fabio Biscegli Jatene ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "topic_name": "Ensino da cirurgia cardiovascular para diferentes gerações",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "DOJgqwmYMKxxPOARvoP6",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "GkPljbxZKTpR5XQl9nze",
                        "topic_duration": "40",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ricardo de Carvalho Lima ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "14:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "topic_name": "Ensino da cirurgia cardiovascular para diferentes gerações",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "DOJgqwmYMKxxPOARvoP6",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "zttkGhY0x9EMVAoFcK13",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "jRhpMKdVR7Y8owgnoviY",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Contribuição da Cirurgia Cardiovascular ao desenvolvimento da Cardiologia / Contribution of Cardiovascular Surgery to the development of Cardiology",
                    "text": "<p>O palestrante terá 30 min &nbsp;e os debatedores, 10 min</p>",
                    "startTime": "15:20",
                    "duration": "40",
                    "agenda": [
                      {
                        "member_id": "4l3989WUqEkyDScf47UK",
                        "topic_duration": "40",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Marcela da Cunha Sales ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "topic_name": "Contribuição da Cirurgia Cardiovascular ao desenvolvimento da Cardiologia / Contribution of Cardiovascular Surgery to the development of Cardiology",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "zttkGhY0x9EMVAoFcK13",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "ZB9U1dRFByzdS98IAGza",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "topic_duration": "40",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Tomas Salerno",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Contribuição da Cirurgia Cardiovascular ao desenvolvimento da Cardiologia / Contribution of Cardiovascular Surgery to the development of Cardiology",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "zttkGhY0x9EMVAoFcK13",
                        "activity_location": "Auditório 5"
                      },
                      {
                        "member_id": "9bpCBQ85pG4g5h1I9TtZ",
                        "activity_name": "ACADEMIA - DEBATES - CIRURGIA CARDIOVASCULAR: PASSADO, PRESENTE E FUTURO",
                        "topic_duration": "40",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Henrique Murad ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "akXbIW6V3Q1UHZQzE0BF",
                        "topic_name": "Contribuição da Cirurgia Cardiovascular ao desenvolvimento da Cardiologia / Contribution of Cardiovascular Surgery to the development of Cardiology",
                        "activity_id": "jRhpMKdVR7Y8owgnoviY",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "zttkGhY0x9EMVAoFcK13",
                        "role_name": "Debatedor(a)",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "oGvrWNBXpknTxo2zuoBR",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "CURSO DE TAVI",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p>No fundo da sala deverá haver espaço para a montagem de 2 equipamentos (simuladores), com logística para que haja circulação entre as mesas, pois a plateia fará aula prática nos equipamentos a partir das 16h45. A montagem do equipamento é de responsabilidade da Edwards, e deverá haver pelo menos um representante da empresa na sala.</p><p>A Edwards poderá colocar banner no auditório, no local que desejar, como patrocinadora do Curso.<br><br>Como se trata de curso com pré inscrição, deverá haver controle de presença dos frequentadores, que assinarão uma folha de presença, que deverá ficar na porta do auditório, com a recepcionista.&nbsp;<br>A SBCCV orientará os inscritos nessa atividade a assinarem a presença.</p><p>Ao final, a lista deverá ser entregue para a Sandra ou Meryt</p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "vklFqYm25ki5o1mzphiQ",
                    "activity_name": "CURSO DE TAVI",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Eduardo Keller Saadi ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "YSTjpav26KV1ydeC6v9p",
                    "activity_name": "CURSO DE TAVI",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Gustavo Ieno Judas ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 2"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "7oOskTICgHKkbzhHnYwR",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Indicações atuais e revisão dos principais ensaios clínicos",
                    "text": "",
                    "startTime": "14:20",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "YSTjpav26KV1ydeC6v9p",
                        "activity_name": "CURSO DE TAVI",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Gustavo Ieno Judas ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Indicações atuais e revisão dos principais ensaios clínicos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "7oOskTICgHKkbzhHnYwR",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "CNgjXk7VDil6Bruf9jP2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Passo a passo do implante",
                    "text": "",
                    "startTime": "15:05",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "vklFqYm25ki5o1mzphiQ",
                        "topic_duration": "15",
                        "activity_name": "CURSO DE TAVI",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Eduardo Keller Saadi ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Passo a passo do implante",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "CNgjXk7VDil6Bruf9jP2",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "GRe5aVdUJkEH8cf9WkeR",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Abertura",
                    "text": "",
                    "startTime": "14:00",
                    "duration": "5",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "Muam84lSWo8wW26mh0tS",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Acessos alternativos",
                    "text": "",
                    "startTime": "15:50",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7qi2vEYdO3teszgHsWwG",
                        "activity_name": "CURSO DE TAVI",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Heraldo Guedis Lobo Filho ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Acessos alternativos",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Muam84lSWo8wW26mh0tS",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "YNVFHS4I2jOJAzpx3ROp",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "16:05",
                    "duration": "15",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "dM1YrlLiclL6jyhALdOY",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TAVI em valvas bicúspides",
                    "text": "",
                    "startTime": "15:20",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "Mcvc4sHHB11aTzQdlAIP",
                        "activity_name": "CURSO DE TAVI",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Fernando Antonio Roquette Reis Filho ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "TAVI em valvas bicúspides",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dM1YrlLiclL6jyhALdOY",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "kph3lOZ9hxapMoILwMAJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Composição e importância do Heart Team",
                    "text": "",
                    "startTime": "14:05",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pHopGlaMmGboS9s4ZJPk",
                        "activity_name": "CURSO DE TAVI",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Composição e importância do Heart Team",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "kph3lOZ9hxapMoILwMAJ",
                        "topic_duration": "15",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "mnwrWCOUOJIQ6vgO9R9F",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Planejamento do implante através da angiotomografia",
                    "text": "",
                    "startTime": "14:35",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "JyS5Mj4rUgRaqWTRMXRx",
                        "topic_duration": "15",
                        "activity_name": "CURSO DE TAVI",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Cledicyon Eloy da Costa",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Planejamento do implante através da angiotomografia",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "mnwrWCOUOJIQ6vgO9R9F",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "pHinza6Tq0MO5PPufRq1",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Anatomia do aparato valvar aórtico e sua relação com TAVI",
                    "text": "",
                    "startTime": "14:50",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "5yrGDXcl3mMyHZSJbuow",
                        "topic_duration": "15",
                        "activity_name": "CURSO DE TAVI",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "José Honório de Almeida Palma Fonseca",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "14:50",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Anatomia do aparato valvar aórtico e sua relação com TAVI",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "pHinza6Tq0MO5PPufRq1",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "wDpzb8CBydtMT1hWYXvl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Treinamento em Simuladores",
                    "text": "",
                    "startTime": "16:20",
                    "duration": "75",
                    "agenda": [
                      {
                        "member_id": "vklFqYm25ki5o1mzphiQ",
                        "activity_name": "CURSO DE TAVI",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Eduardo Keller Saadi ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Treinamento em Simuladores",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "wDpzb8CBydtMT1hWYXvl",
                        "activity_location": "Auditório 2",
                        "topic_duration": "75",
                        "role_name": "Coordenador(a)",
                        "topic_startTime": "16:20"
                      },
                      {
                        "member_id": "YSTjpav26KV1ydeC6v9p",
                        "activity_name": "CURSO DE TAVI",
                        "topic_duration": "75",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Gustavo Ieno Judas ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Coordenador(a)",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "topic_name": "Treinamento em Simuladores",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "wDpzb8CBydtMT1hWYXvl",
                        "activity_location": "Auditório 2",
                        "topic_startTime": "16:20"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "yyCwXk8rq3T29UbqBPb3",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "oGvrWNBXpknTxo2zuoBR",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Principais complicações e como tratar",
                    "text": "",
                    "startTime": "15:35",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "8vWrWlQ4IZxCMIoSQAF5",
                        "activity_name": "CURSO DE TAVI",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Magaly Arrais dos Santos",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "15:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Principais complicações e como tratar",
                        "activity_id": "oGvrWNBXpknTxo2zuoBR",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "yyCwXk8rq3T29UbqBPb3",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "ozjx1imQzVknM8bTw3ex",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "ABRECCV - MESA REDONDA - O MERCADO PARA O JOVEM CIRURGIÃO CARDIOVASCULAR",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "10:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "uc7ygrqrXZ8jOy6l9cZQ",
                    "activity_name": "ABRECCV - MESA REDONDA - O MERCADO PARA O JOVEM CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "10:00",
                    "member_name": "Jéssica Cordeiro de Siqueira Campos ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "activity_id": "ozjx1imQzVknM8bTw3ex",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5"
                  },
                  {
                    "member_id": "caInCe2UEo2vJ5ez9FAN",
                    "activity_name": "ABRECCV - MESA REDONDA - O MERCADO PARA O JOVEM CIRURGIÃO CARDIOVASCULAR",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "10:00",
                    "member_name": "Diogo Assis Souza ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "ozjx1imQzVknM8bTw3ex",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 2"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "EfXBKVrDNFg9k3XsGxm2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "ozjx1imQzVknM8bTw3ex",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Mercado de trabalho: como se inserir com sucesso em grandes Centros",
                    "text": "",
                    "startTime": "10:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "9jXNcyMycG2lokoQ1TWN",
                        "activity_name": "ABRECCV - MESA REDONDA - O MERCADO PARA O JOVEM CIRURGIÃO CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:00",
                        "member_name": "Márcio Rufino Barbosa Jr. ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "10:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Mercado de trabalho: como se inserir com sucesso em grandes Centros",
                        "activity_id": "ozjx1imQzVknM8bTw3ex",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "EfXBKVrDNFg9k3XsGxm2",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "IldrycYli1sIIiQtTMxQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "ozjx1imQzVknM8bTw3ex",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Mercado de trabalho: a criação de um Serviço de Cirurgia Cardiovascular de Excelência",
                    "text": "",
                    "startTime": "10:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "ThV5wKk60ERXMcvhChfj",
                        "activity_name": "ABRECCV - MESA REDONDA - O MERCADO PARA O JOVEM CIRURGIÃO CARDIOVASCULAR",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "10:00",
                        "member_name": "Sérgio Francisco dos Santos Júnior ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "10:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "ozjx1imQzVknM8bTw3ex",
                        "topic_name": "Mercado de trabalho: a criação de um Serviço de Cirurgia Cardiovascular de Excelência",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "IldrycYli1sIIiQtTMxQ",
                        "activity_location": "Auditório 2"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "qAbAzU7VJiV2h4h1PUKN",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "Reunião BJCVS",
                "text": "",
                "startTime": "12:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "t0noaE6kpjQIrzR8WsUW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "qAbAzU7VJiV2h4h1PUKN",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Reunião BJCVS",
                    "text": "",
                    "startTime": "12:30",
                    "duration": "60 ",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "sebySwGGH8D2dsfC04A7",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "MESA REDONDA I - CORONÁRIA ",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong></p>",
                "startTime": "08:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "8xaAN7yNUDDOVNkWcgFG",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:00",
                    "member_name": "André Raimundo Franca Guimarães ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_name": "MESA REDONDA I - CORONÁRIA ",
                    "activity_location": "Auditório Principal",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "7Y3TK2LEzeXZSlatO44l",
                    "activity_name": "MESA REDONDA I - CORONÁRIA ",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:00",
                    "member_name": "Rodrigo Mussi Milani ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "9XbkcRIaJt89kw9ZuU9q",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Revascularização miocárdica com insuficiência mitral isquêmica: Quando e como intervir na valva mitral?",
                    "text": "",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "RzhhxnIjXUFxXnBViKDk",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Fernando Antibas Atik ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Revascularização miocárdica com insuficiência mitral isquêmica: Quando e como intervir na valva mitral?",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "9XbkcRIaJt89kw9ZuU9q",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "YzsYY0wKM39V8IcqujDX",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Endarterectomia de coronária. Ainda há espaço?",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "GkPljbxZKTpR5XQl9nze",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Ricardo de Carvalho Lima ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Endarterectomia de coronária. Ainda há espaço?",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "YzsYY0wKM39V8IcqujDX",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "dfooXZU55SbOl55TsTyA",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "De acordo com a Medicina Baseada em Evidências, qual o segundo enxerto na revascularização do miocárdio?",
                    "text": "",
                    "startTime": "08:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "wQvCDxqKx3hrExuXNGmz",
                        "topic_duration": "15",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Maurílio Onofre Deininger ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "De acordo com a Medicina Baseada em Evidências, qual o segundo enxerto na revascularização do miocárdio?",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dfooXZU55SbOl55TsTyA",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "dzuZLEPCUFqgay6zvwod",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "CIV pós infarto. Técnicas e resultados",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "87zqmcFtJ9GNHX8PujS0",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Roberto Gomes de Carvalho",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "CIV pós infarto. Técnicas e resultados",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "dzuZLEPCUFqgay6zvwod",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qSbIbGE82oIdAKFX1HiX",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Estratégias do tratamento cirúrgico da coronária anômala em função do trajeto maligno",
                    "text": "",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "3YKHsRROT0UV32P4W7Wm",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Paulo Manuel Pêgo-Fernandes ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "topic_name": "Estratégias do tratamento cirúrgico da coronária anômala em função do trajeto maligno",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qSbIbGE82oIdAKFX1HiX",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qzUTxOrtZzw81ph4d0mt",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Veia safena no touch - quais as evidências?",
                    "text": "",
                    "startTime": "08:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "zUJF3rGEzCCujnzfeA9P",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Walter José Gomes ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "topic_name": "Veia safena no touch - quais as evidências?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qzUTxOrtZzw81ph4d0mt",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "srFQqdZeLS9JqERx9G8A",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Infarto agudo do miocárdio no tempo dos stents. Quando indicar tratamento cirúrgico? ",
                    "text": "",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "BTlpXRTvn56uWDHODHh2",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Fabio Biscegli Jatene ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "topic_name": "Infarto agudo do miocárdio no tempo dos stents. Quando indicar tratamento cirúrgico? ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "srFQqdZeLS9JqERx9G8A",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "activity_location": "Auditório Principal",
                        "topic_startTime": "09:45"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "vscS4XBpP8g14hCCW9Ke",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Benefícios da medida de fluxo nos enxertos coronarianos. Mito ou realidade?",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "YcEGvs1EHY5MaUR0DcWL",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:00",
                        "member_name": "Rodrigo Coelho Segalote ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Benefícios da medida de fluxo nos enxertos coronarianos. Mito ou realidade?",
                        "activity_id": "sebySwGGH8D2dsfC04A7",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "vscS4XBpP8g14hCCW9Ke",
                        "activity_name": "MESA REDONDA I - CORONÁRIA ",
                        "activity_location": "Auditório Principal",
                        "topic_startTime": "09:30"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "zOmkVpmhgazz4WgKF5Xs",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "sebySwGGH8D2dsfC04A7",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "10:00",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "smetqLBuKFSANKYjyNzX",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                "text": "<p><i><strong>Cada trabalho disporá de 8 minutos para apresentação, destinados para a explanação do autor, seguidos de 2 minutos para considerações do comentador (sem slides), 2 minutos para réplica, 3 minutos para plateia.</strong></i></p><p>&nbsp;</p><p>&nbsp;</p><p><strong>Dinâmica: </strong>Coordenadores ficam no palco, na mesa diretora, durante todo o tempo. Os apresentadores dos Temas Livres sobem ao púlpito à medida que forem chamados pelos Coordenadores</p><p>A Comissão avaliadora ficará na plateia. Deverá ser distribuído aos avaliadores a planilha de julgamento dos Temas Livres da Sessão Especial (retirar com a Sandra os envelopes). Ao final da Sessão, a coordenadora dos Temas Livres deverá recolher as planilhas com as notas e entregar para a Sandra.</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Caso os coordenadores da mesa julguem necessário, deverá ser lido o mini currículo do apresentador antes de iniciar sua palestra.</strong></p>",
                "startTime": "09:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "NsfYLwC5wmSrRbSVh17F",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "acceptInvite": false,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Antonio Carlos de Almeida Barbosa Filho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "requireConfirm": true,
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "VBZgvFDBMbMvqvUcyrQ6",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Vinicius José da Silva Nina",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "caInCe2UEo2vJ5ez9FAN",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Diogo Assis Souza ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "LHp66lMTiqQ3ZbPXi51K",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Gabriel Rodrigues Bittencourt ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "9L8vYBbfYLUTdMFiDQmH",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Lucas Figueredo Cardoso",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "dmBJ4PuwRRIZOc6Cnjd1",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "acceptInvite": false,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Marco Antonio de Sousa do Vale ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "wWTa7TFo7Jj7G0Ab1e7r",
                    "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "acceptInvite": false,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "09:00",
                    "member_name": "Isabella Gomes Maggessi",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "36jDwzx75EOTOOJD2mx2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "4º lugar: TLL03 -  Progresso nas tecnologias cirúrgicas: engenharia tecidual para cardiopatia congênita",
                    "text": "<p>Autores: Amanda Arrais Bento de Souza, Theodoro Zigmundo Servolo, Theodoro Zigmundo Servolo<br>Instituição: Universidade Santo Amaro (SP)</p>",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "MylcOYoQFfJTDotsLSCv",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Amanda Arrais Bento de Souza",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "36jDwzx75EOTOOJD2mx2",
                        "topic_startTime": "09:30",
                        "activity_location": "Auditório 4",
                        "topic_name": "4º lugar: TLL03 -  Progresso nas tecnologias cirúrgicas: engenharia tecidual para cardiopatia congênita"
                      },
                      {
                        "member_id": "N5eWisZgJtBZpK3A1Wqh",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Pâmela Cristina Dutil Ribeiro ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador(a)",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "36jDwzx75EOTOOJD2mx2",
                        "activity_location": "Auditório 4",
                        "topic_name": "4º lugar: TLL03 -  Progresso nas tecnologias cirúrgicas: engenharia tecidual para cardiopatia congênita"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "MGeazov39pA2xeFWQ7EL",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "2º lugar: TLL02 - Avaliação de viabilidade anatômica por angiotomografia para troca valvar aórtica transcateter. Estudo de coorte de série de casos, em um hospital da rede privada de Belo Horizonte",
                    "text": "<p>Autores: Arthur de Vasconcellos Rocha, Vitor Lanza Avelar Almeida, Isabella Victória da Cunha Peixoto Ribeiro, Eduardo Augusto Victor Rocha<br>Instituição: Faculdade Ciências Médicas de Minas Gerais (MG)</p>",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pYmMGn81MHYnGsJ2dpVo",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Adnaldo da Silveira Maia",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "MGeazov39pA2xeFWQ7EL",
                        "topic_startTime": "09:15",
                        "activity_location": "Auditório 4",
                        "topic_name": "2º lugar: TLL02 - Avaliação de viabilidade anatômica por angiotomografia para troca valvar aórtica transcateter. Estudo de coorte de série de casos, em um hospital da rede privada de Belo Horizonte"
                      },
                      {
                        "member_id": "bcEVHo46xew8ApJFUrlE",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Arthur de Vasconcellos Rocha",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "MGeazov39pA2xeFWQ7EL",
                        "topic_startTime": "09:15",
                        "activity_location": "Auditório 4",
                        "topic_name": "2º lugar: TLL02 - Avaliação de viabilidade anatômica por angiotomografia para troca valvar aórtica transcateter. Estudo de coorte de série de casos, em um hospital da rede privada de Belo Horizonte"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "Q0CI2aH6mhTJzd8joo1d",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": " 3º lugar:  TLL01 - O impacto da COVID-19 nas cirurgias cardiovasculares no Estado do Paraná",
                    "text": "<p>Autores: Laura Fermiano Bastos, Rui Manuel de Sousa Sequeira Antunes de Almeida<br>Instituição: Centro Universitário da Fundação Assis Gurgacz (PR)</p>",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "l84cpXs5oD3FTmTShdOa",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Laura Fermiano Bastos ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "09:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Q0CI2aH6mhTJzd8joo1d",
                        "activity_location": "Auditório 4",
                        "topic_name": " 3º lugar:  TLL01 - O impacto da COVID-19 nas cirurgias cardiovasculares no Estado do Paraná"
                      },
                      {
                        "member_id": "1uk9yntz7n0s3s26AoOH",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Alvaro Monteiro Perazzo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Q0CI2aH6mhTJzd8joo1d",
                        "topic_startTime": "09:00",
                        "activity_location": "Auditório 4",
                        "topic_name": " 3º lugar:  TLL01 - O impacto da COVID-19 nas cirurgias cardiovasculares no Estado do Paraná"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "cTfmLbJ6etz0IubfHBiD",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "smetqLBuKFSANKYjyNzX",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "1º lugar TLL04 -  Fatores preditores de extubação precoce no pós-operatório de cirurgia cardíaca",
                    "text": "<p>Autores: Guilherme Kallás Hueb, Maisa Marques Barros, William Burato Evaristo, Maurício Landulfo Jorge Guerrieri, Alexandre Ciappina Hueb<br>Instituição: Universidade do Vale do Sapucaí - UNIVÁS (MG)</p>",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "TgKfqHH4ludbvVtTKtqx",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Guilherme Kallás Hueb",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "cTfmLbJ6etz0IubfHBiD",
                        "topic_startTime": "09:45",
                        "activity_location": "Auditório 4",
                        "topic_name": "1º lugar TLL04 -  Fatores preditores de extubação precoce no pós-operatório de cirurgia cardíaca"
                      },
                      {
                        "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                        "activity_name": "DBLACCV - SESSÃO DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "09:00",
                        "member_name": "Patricia Cristina Celestino",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "smetqLBuKFSANKYjyNzX",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "cTfmLbJ6etz0IubfHBiD",
                        "topic_startTime": "09:45",
                        "activity_location": "Auditório 4",
                        "topic_name": "1º lugar TLL04 -  Fatores preditores de extubação precoce no pós-operatório de cirurgia cardíaca"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "uo5a2HlSpFwyK4Lqdra2",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - DESAFIO DAS LIGAS",
                "text": "<p><strong>Dinâmica : </strong>Atividade coordenada pela Diretoria do Departamento. Deve haver apenas uma assistente de palco</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "17:45",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "wWTa7TFo7Jj7G0Ab1e7r",
                    "activity_name": "DBLACCV - DESAFIO DAS LIGAS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "17:45",
                    "member_name": "Isabella Gomes Maggessi",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "uo5a2HlSpFwyK4Lqdra2",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "gAPfW2GOCBtLPWJLwYt5",
                    "activity_name": "DBLACCV - DESAFIO DAS LIGAS",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "17:45",
                    "member_name": "Eduarda Cabral Braga da Costa",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "uo5a2HlSpFwyK4Lqdra2",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "LPRy84Wq1kUNF5aiULFG",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "uo5a2HlSpFwyK4Lqdra2",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "DESAFIO DAS LIGAS",
                    "text": "",
                    "startTime": "17:45",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "vCNsfWX0de81L4Cg9KM9",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - Abertura do 12º Congresso Acadêmico de Cirurgia Cardiovascular e apresentação dos resultados da Gestão",
                "text": "<p>Abertura será &nbsp;feita pelos coordenadores</p><p>&nbsp;</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
                    "activity_name": "DBLACCV - Abertura do 12º Congresso Acadêmico de Cirurgia Cardiovascular e apresentação dos resultados da Gestão",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Fabrício Lara Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "vCNsfWX0de81L4Cg9KM9",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "activity_name": "DBLACCV - Abertura do 12º Congresso Acadêmico de Cirurgia Cardiovascular e apresentação dos resultados da Gestão",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "vCNsfWX0de81L4Cg9KM9",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "KAhRPUIzvD5zJznPMwpI",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vCNsfWX0de81L4Cg9KM9",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Abertura do 12º Congresso Acadêmico de Cirurgia Cardiovascular e apresentação dos resultados da Gestão",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "10",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "vDqh9KccjBOsAdBlyB4P",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "ÁREA DE EXPOSIÇÃO",
                "name": " DBLACCV - SESSÃO DE PÔSTER II",
                "text": "",
                "startTime": "16:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:00",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "event_name": "49º Congresso da SBCCV • 2023"
                  },
                  {
                    "member_id": "lXt9fXUeNk3UTwg0g3hM",
                    "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:00",
                    "member_name": "José Kleberth Tenório Filho ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Coordenador(a)",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "event_name": "49º Congresso da SBCCV • 2023"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "0vNpMSNWyf7VNVzQHBiW",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO11 - Correção endovascular de pseudoaneurisma de aorta torácica após operação de Bentall e De Bono com dispositivo de oclusão percutânea ",
                    "text": "<p>Autores: Diego Maia Martins, João Galantier, Ivo Richter, André Luiz Mendes Martins, José Honório de Almeida Palma da Fonseca&nbsp;<br>Instituição: Hospital do Coração - HCor (SP)</p>",
                    "startTime": "16:05",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "s3183n94ktnCfjlUXRSu",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Diego Maia Martins ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:05",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO11 - Correção endovascular de pseudoaneurisma de aorta torácica após operação de Bentall e De Bono com dispositivo de oclusão percutânea ",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "0vNpMSNWyf7VNVzQHBiW"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "NCuHfbpSynwDPuwAl57X",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO13 - Origem e percurso anômalos da artéria coronariana descendente anterior: relato de caso ",
                    "text": "<p>Autores: Álvaro Perazzo, Bruna Dias Guimarães, Átala Raíssa Oliveira Santos, Alexandre Motta de Menezes,Pedro Rafael Salerno, Ricardo de Carvalho Lima&nbsp;<br>Instituição: Departamento de Cirurgia Cardiovascular, Pronto Socorro Cardiológico de Pernambuco, Universidade de Pernambuco (PE)</p>",
                    "startTime": "16:15",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "1uk9yntz7n0s3s26AoOH",
                        "topic_duration": "05",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Alvaro Monteiro Perazzo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "topic_name": "PO13 - Origem e percurso anômalos da artéria coronariana descendente anterior: relato de caso ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "NCuHfbpSynwDPuwAl57X"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "NYSonx85dHXHG1hXfzuh",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO14 - Tratamento de ectasia ânulo-aórtica via mini Bentall De Bono: um relato de caso ",
                    "text": "<p>Autores: Vítor Caldeira Leite Silva, Maria Clara de Almeida Ferreira, Vitória Patrícia Rodrigues Cunha, Gabrielly Santana Carvalho, Isaac Azevedo Silva, Ricardo Barros Corso&nbsp;<br>Instituição: Universidade Católica de Brasília - UCB (DF)</p>",
                    "startTime": "16:20",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "5bkqQmR4bykcundtemfw",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "level": "t",
                        "acceptInvite": false,
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Vítor Caldeira Leite Silva",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:20",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "topic_name": "PO14 - Tratamento de ectasia ânulo-aórtica via mini Bentall De Bono: um relato de caso ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "NYSonx85dHXHG1hXfzuh"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "O1Uf8ZbTViCrOYE0rovQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO15 - Dissecção aórtica tipo a/i aguda. Paciente sobrevivente tratado com seis diferentes procedimentos cirúrgicos ao longo de 11 anos ",
                    "text": "<p>Autores: Vitória Patrícia Rodrigues Cunha, Gabriel Lins de Oliveira, Gabrielly Santana Carvalho, Letícia Cruz Cajueiro, Vítor Caldeira Leite Silva, Ricardo Barros Corso&nbsp;<br>Instituição: Centro Universitário do Planalto Central Aparecido dos Santos - UNICEPLAC (DF)</p>",
                    "startTime": "16:25",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "3Q5KiYeGw70EWSz9XfJS",
                        "topic_duration": "05",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Vitória Patrícia Rodrigues Cunha",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:25",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "topic_name": "PO15 - Dissecção aórtica tipo a/i aguda. Paciente sobrevivente tratado com seis diferentes procedimentos cirúrgicos ao longo de 11 anos ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "O1Uf8ZbTViCrOYE0rovQ"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "QOJdIpolu6RMsdMiMa2z",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO18 - Dissecção de aorta devido a trauma contuso em idade pré-escolar - Relato de caso ",
                    "text": "<p>Autores: Gabriella Meneses Rocha Borges de Albuquerque, Emanoel Pimentel Cruz, Fabricio Barreira Pombo, Jeanne Araújo Bandeira Gomes, Isabel Cristina Leite Maia, Ítalo Magalhães de Araújo&nbsp;<br>Instituição: Hospital de Messejana Dr. Carlos Alberto Studart Gomes (CE)</p>",
                    "startTime": "16:40",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "iTQuvZOVhMEUlf5NvGy5",
                        "topic_duration": "05",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "acceptInvite": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Gabriella Meneses Rocha Borges de Albuquerque",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:40",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO18 - Dissecção de aorta devido a trauma contuso em idade pré-escolar - Relato de caso ",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "QOJdIpolu6RMsdMiMa2z"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "ayDUGAoQsivkFVQ1Q3o5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO10 - Implante percutâneo de valva mitral em gestante portadora de febre reumática: relato de caso ",
                    "text": "<p>Autores: Herta Gonçalves Parente Pinheiro Teles, Giovanna de Souza Galdino&nbsp;<br>Instituição: Faculdade de Medicina Estácio de Juazeiro do Norte (CE)</p>",
                    "startTime": "16:00",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "FQZiljUgoUXCPeFVdCAR",
                        "topic_duration": "30",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Herta Gonçalves Parente Pinheiro Teles",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "SESSÃO DE PÔSTER II",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "ayDUGAoQsivkFVQ1Q3o5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "f6S11hRk1ljbp0JHh1xj",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO16 - Aneurisma gigante de coronária direita: um relato de caso ",
                    "text": "<p>Autores: Cristina Sofia Candia Barrientos, Paula Ribeiro de Britto Borges, Marcelo Braga Ivo, Luiz Claudio Moreira Lima, Fernando Roquette Reis, Rodrigo de Castro Bernardes&nbsp;<br>Instituição: Hospital Madre Teresa de Belo Horizonte (MG)</p>",
                    "startTime": "16:30",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "SDJfKH7gba3M4qGyn3EP",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Cristina Sofia Candia Barrientos ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "topic_name": "PO16 - Aneurisma gigante de coronária direita: um relato de caso ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "f6S11hRk1ljbp0JHh1xj"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "jQVG4BmSB1VLN3trQF8D",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO12 - Reversão de morte súbita por coronária direita anômala: relato de caso ",
                    "text": "<p>Autores: Maria Alice Silva Vasconcelos, Isadora Rênia Lucena Oliveira, Giovanna Louise bezerra lima, Cláudio Mendes Silva, Raimundo de Barros Araújo Júnior, Wanderson da Silva Nery&nbsp;<br>Instituição: Hospital Prontomed Adulto (PI)</p>",
                    "startTime": "16:10",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "2DaUuGzc7pVWx5UPRKkR",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "topic_duration": "05",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Maria Alice Silva Vasconcelos ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO12 - Reversão de morte súbita por coronária direita anômala: relato de caso ",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "jQVG4BmSB1VLN3trQF8D",
                        "topic_startTime": "16:10"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "qECEZfRHMDv70bgL7Qjf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vDqh9KccjBOsAdBlyB4P",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "PO17 - Comunicação interventricular de parede septal inferior após infarto agudo do miocárdio ",
                    "text": "<p>Autores: Manuela Cristina Adsuara Pandolfi, Ana Claudia Pera Corassa, Maria Eduarda Chagas Ferreira de Sá, Luís Roberto Palma Dallan, Luís Alberto Oliveira Dallan, Fabio B Jatene&nbsp;<br>Instituição: Faculdade de Medicina da Universidade de São Paulo (SP)</p>",
                    "startTime": "16:35",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "RDDwckeDaQidJkVme1xz",
                        "topic_duration": "05",
                        "activity_name": " DBLACCV - SESSÃO DE PÔSTER II",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:00",
                        "member_name": "Manuela Cristina Adsuara Pandolfi",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Autor",
                        "topic_startTime": "16:35",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "n9ZrCK1fdZL8yJALTixT",
                        "topic_name": "PO17 - Comunicação interventricular de parede septal inferior após infarto agudo do miocárdio ",
                        "activity_id": "vDqh9KccjBOsAdBlyB4P",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "qECEZfRHMDv70bgL7Qjf"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "vnIqdDt8P6GWsRqMOU2a",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 2",
                "name": "SIMPÓSIO EDWARDS",
                "text": "<p><strong>Dinâmica: </strong>Atividade organizada pela própria empresa. É de responsabilidade do evento providenciar toda a estrutura de apoio (audiovisual, midia desk, assistente de palco e recepcionista de apoio na plateia)</p><p>Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra para perguntas</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "12:30",
                "duration": null,
                "materials": [],
                "agenda": [],
                "topics": [
                  {
                    "materials": [],
                    "id": "3NeLa4N1o4TYLEMFSFHl",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Management and current trends in mitral surgery treatment Minimal access mitral surgery - repair and replacement Robotic mitral surgery Contraindications to minimal access mitral surgery",
                    "text": "",
                    "startTime": "13:20",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "VfFO3FTnWduNYdCq9nCY",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Robinson Poffo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Management and current trends in mitral surgery treatment Minimal access mitral surgery - repair and replacement Robotic mitral surgery Contraindications to minimal access mitral surgery",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "3NeLa4N1o4TYLEMFSFHl",
                        "topic_duration": "15",
                        "topic_startTime": "13:20"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "4A6f3QrdxcUb5WbKXepb",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Case Presentation:  challenge patient",
                    "text": "",
                    "startTime": "13:05",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7DX2r7eaP3qnXxnfez1L",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Robert Saeid Farivar",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Case Presentation:  challenge patient",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "4A6f3QrdxcUb5WbKXepb",
                        "topic_duration": "15",
                        "topic_startTime": "13:05"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "6STQe53iOaYzyBJAVbyU",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Welcome and Introduction",
                    "text": "",
                    "startTime": "12:30",
                    "duration": "05",
                    "agenda": [
                      {
                        "member_id": "BTlpXRTvn56uWDHODHh2",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Fabio Biscegli Jatene ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "topic_startTime": "12:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Welcome and Introduction",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "6STQe53iOaYzyBJAVbyU",
                        "topic_duration": "05"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "KdBSVGCqsug5lM9dWoYb",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Real-word clinical evidence Communicate insights from current evidence and discuss future considerations",
                    "text": "",
                    "startTime": "12:50",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7DX2r7eaP3qnXxnfez1L",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Robert Saeid Farivar",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Real-word clinical evidence Communicate insights from current evidence and discuss future considerations",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "KdBSVGCqsug5lM9dWoYb",
                        "topic_startTime": "12:50"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "lo0FjFD6s6MBmNAKNTVm",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Best practices related to advanced technology, techniques and patient management in mitral surgery treatment.  Durability of mitral valve repair for mitral regurgitation due to degenerative mitral valve disease",
                    "text": "",
                    "startTime": "12:35",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7DX2r7eaP3qnXxnfez1L",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Robert Saeid Farivar",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Best practices related to advanced technology, techniques and patient management in mitral surgery treatment.  Durability of mitral valve repair for mitral regurgitation due to degenerative mitral valve disease",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "lo0FjFD6s6MBmNAKNTVm",
                        "topic_startTime": "12:35"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "tqRRWJWMlPYNu4XQKzy0",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Round table - discussion",
                    "text": "",
                    "startTime": "13:35",
                    "duration": "25",
                    "agenda": [
                      {
                        "member_id": "BTlpXRTvn56uWDHODHh2",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Fabio Biscegli Jatene ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Round table - discussion",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "tqRRWJWMlPYNu4XQKzy0",
                        "topic_startTime": "13:35",
                        "topic_duration": "25"
                      },
                      {
                        "member_id": "MarhnVGRhL3kSSe6uWVY",
                        "activity_name": "SIMPÓSIO EDWARDS",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "12:30",
                        "member_name": "Marco Antonio Praça Oliveira ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Speaker",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "R5olvCc27Aj7fO4JfmfB",
                        "activity_id": "vnIqdDt8P6GWsRqMOU2a",
                        "topic_name": "Round table - discussion",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "tqRRWJWMlPYNu4XQKzy0",
                        "topic_startTime": "13:35",
                        "topic_duration": "25"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "wmPePgdQKhUq2DTsLBlM",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - CONFERÊNCIA: Transplante cardíaco e dispositivos de assistência ventriculares",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "10:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "2eC5tG3Rf3IgH8ZRNRA0",
                    "activity_name": "DBLACCV - CONFERÊNCIA: Transplante cardíaco e dispositivos de assistência ventriculares",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "member_name": "Fabrício Lara Carvalho",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wmPePgdQKhUq2DTsLBlM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4",
                    "activity_startTime": "10:00",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "MylcOYoQFfJTDotsLSCv",
                    "activity_name": "DBLACCV - CONFERÊNCIA: Transplante cardíaco e dispositivos de assistência ventriculares",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "member_name": "Amanda Arrais Bento de Souza",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wmPePgdQKhUq2DTsLBlM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4",
                    "activity_startTime": "10:00",
                    "role_name": "Coordenador(a)"
                  },
                  {
                    "member_id": "TNegaNCo8I6SdabN45Gc",
                    "activity_name": "DBLACCV - CONFERÊNCIA: Transplante cardíaco e dispositivos de assistência ventriculares",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "10:00",
                    "member_name": "Samuel Padovani Steffen ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Conferencista",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "uYOH6vwplH1OSKByONkf",
                    "activity_id": "wmPePgdQKhUq2DTsLBlM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "KVrwxiqMIc0TzgLjN584",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wmPePgdQKhUq2DTsLBlM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "CONFERÊNCIA: Transplante cardíaco e dispositivos de assistência ventriculares",
                    "text": "",
                    "startTime": "10:00",
                    "duration": "30",
                    "agenda": []
                  }
                ]
              },
              {
                "id": "wvvjGWPA8BAi1AasIMRm",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório Principal",
                "name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                "text": "<p><strong>Dinâmica:&nbsp;</strong>Coordenadores ficam no palco, na mesa diretora, durante todo o tempo. Os apresentadores dos Temas Livres sobem ao púlpito à medida que forem chamados pelos Coordenadores</p><p>A Comissão avaliadora ficará na plateia. Deverá ser distribuído aos avaliadores a planilha de julgamento dos Temas Livres da Sessão Especial (retirar com a Sandra os envelopes). Ao final da Sessão, a coordenadora dos Temas Livres deverá recolher as planilhas com as notas e entregar para a Sandra.</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Caso os coordenadores da mesa julguem necessário, deverá ser lido o mini currículo do apresentador antes de iniciar sua palestra</strong></p>",
                "startTime": "14:00",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "dzKLi1kcJnITqT121rO9",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Mauro Paes Leme de Sá ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "G7lcUh6ajYPZpR2Xf60Y",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Wilson Luiz da Silveira ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "PKjfvOcxsrIemox3jl4E",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "acceptInvite": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Mauro Barbosa Arruda Filho ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "TawRmR2TVs1QsxUf0Ah3",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Marcos Gradim Tiveron ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "ekCcVwDIzIrMotDU7WJn",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Alexander John Pessoa Grant Anderson ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "n9Z6BDJ50t5jBtPyY8Bb",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Rubens Tofano de Barros ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  },
                  {
                    "member_id": "FjybEQe6bu0giHrR1tNN",
                    "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                    "requireSchedule": false,
                    "requireConfirm": true,
                    "level": "a",
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "14:00",
                    "member_name": "Fernando Ribeiro Moraes Neto ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "role_name": "Comissão",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "fr7R3Hhbqel3iunFkQzN",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "activity_location": "Auditório Principal"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "5riNoZGfx3mJQYjuS5I0",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "1º lugar - TL05 - Avaliação  do valor de linfócitos no pós operatório imediato como preditor de morbimortalidade em pacientes submetidos a cirurgia cardiovascular com circulação extracorpórea em um Hospital da rede pública de Belo Horizonte: estudo de coorte retrospectivo",
                    "text": "<p><i><strong>Autores: </strong>Renata Costa Café de Castro, Paula Natividade Costa, </i>Isabella Victória da Cunha Peixoto Ribeiro, Maria Paula Parreira, <i>Eduardo Augusto Victor Rocha</i></p><p><br><i><strong>Instituição:</strong> Faculdade Ciências Médicas de Minas Gerais (MG)</i></p>",
                    "startTime": "15:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "qzUAAtIhJ88i1uDErvy8",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Renata Costa Café de Castro",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "5riNoZGfx3mJQYjuS5I0",
                        "activity_location": "Auditório Principal",
                        "topic_name": "1º lugar - TL05 - Avaliação  do valor de linfócitos no pós operatório imediato como preditor de morbimortalidade em pacientes submetidos a cirurgia cardiovascular com circulação extracorpórea em um Hospital da rede pública de Belo Horizonte: estudo de coorte retrospectivo"
                      },
                      {
                        "member_id": "Z8uiF2pLISUKj38hBtiT",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Valquiria Pelisser Campagnucci ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "15:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "5riNoZGfx3mJQYjuS5I0",
                        "activity_location": "Auditório Principal",
                        "topic_name": "1º lugar - TL05 - Avaliação  do valor de linfócitos no pós operatório imediato como preditor de morbimortalidade em pacientes submetidos a cirurgia cardiovascular com circulação extracorpórea em um Hospital da rede pública de Belo Horizonte: estudo de coorte retrospectivo"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "FKEFQfIgMeqn5X7mZSHJ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TL01 - Desempenho do homoenxerto descelularizado como substituto valvar pulmonar em cardiopatias congênitas",
                    "text": "<p><i><strong>Autores: </strong>Flávia Cristina Kufner, Fábio Binhara Navarro, Carlos Henrique Gori Gomes</i></p><p><br><i><strong>Instituição: </strong>Hospital Dr. Jeser Amarante Faria (SC)</i></p>",
                    "startTime": "14:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "84y87yS54zyXPIQBBhdz",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Flávia Cristina Kufner ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "FKEFQfIgMeqn5X7mZSHJ",
                        "topic_name": "TL01 - Desempenho do homoenxerto descelularizado como substituto valvar pulmonar em cardiopatias congênitas",
                        "activity_location": "Auditório Principal"
                      },
                      {
                        "member_id": "xOE7su8C93MoAlR0hIgK",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Alexandre Ciappina Hueb ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "14:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "topic_name": "TL01 - Desempenho do homoenxerto descelularizado como substituto valvar pulmonar em cardiopatias congênitas",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "FKEFQfIgMeqn5X7mZSHJ",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "JZ6h4qDkvSXmgspQTBmN",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "2º lugar • TL08 - Impacto da fibrilação atrial pré-operatória persistente ou permanente nos resultados perioperatórios da cirurgia de revascularização do miocárdio: uma análise pareada por escore de propensão",
                    "text": "<p><i><strong>Autores: </strong>Álvaro Rösler, Gustavo Ferreira, Vinicius Prediger, Jonathan Fraportti, Marcela da Cunha Sales, Fernando Lucchese</i></p><p><br><i><strong>Instituição:</strong> Hospital São Francisco - Centro de Pesquisas em Cirurgia Cardiovascular (RS)</i></p>",
                    "startTime": "15:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "2Z92kFxS6j47faXz48Ky",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carla de Oliveira ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador(a)",
                        "topic_startTime": "15:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "JZ6h4qDkvSXmgspQTBmN",
                        "activity_location": "Auditório Principal",
                        "topic_name": "2º lugar • TL08 - Impacto da fibrilação atrial pré-operatória persistente ou permanente nos resultados perioperatórios da cirurgia de revascularização do miocárdio: uma análise pareada por escore de propensão"
                      },
                      {
                        "member_id": "50uvA0cJpDqqceyzWusk",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Alvaro Rösler ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "15:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "JZ6h4qDkvSXmgspQTBmN",
                        "activity_location": "Auditório Principal",
                        "topic_name": "2º lugar • TL08 - Impacto da fibrilação atrial pré-operatória persistente ou permanente nos resultados perioperatórios da cirurgia de revascularização do miocárdio: uma análise pareada por escore de propensão"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "TgG5ul0PVIAWinSvYHJO",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TL07 - Implicações da captação de órgãos em longa distância na mortalidade após o transplante cardíaco",
                    "text": "<p><i><strong>Autores: </strong>Lucas Figueredo Cardoso, Fabiana G. Marcondes-Braga, Samuel Padovani Steffen, Fábio Antonio Gaiotto, Fernando Bacal, Fabio B. Jatene</i></p><p><br><i><strong>Instituição: </strong>Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (SP)</i></p>",
                    "startTime": "15:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "9L8vYBbfYLUTdMFiDQmH",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Lucas Figueredo Cardoso",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "15:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "TgG5ul0PVIAWinSvYHJO",
                        "topic_name": "TL07 - Implicações da captação de órgãos em longa distância na mortalidade após o transplante cardíaco",
                        "activity_location": "Auditório Principal"
                      },
                      {
                        "member_id": "nC3O0eUNDHmvFAfrOURQ",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Diego Sarty Vianna ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "15:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL07 - Implicações da captação de órgãos em longa distância na mortalidade após o transplante cardíaco",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "TgG5ul0PVIAWinSvYHJO",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "Tt6FYr5JIGdTBbk7EXAC",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TL02 - Estudo prospectivo, randomizado e multicêntrico nacional para avaliar se é possível a operação da raiz da aorta e da aorta ascendente sem transfusão sanguínea e sem mortalidade",
                    "text": "<p><i><strong>Autores:</strong> Ricardo Ribeiro Dias, José Augusto Duncan Santiago, Vagner Madrini Júnior, Marcela da Cunha Sales, Mario Issa, Fábio B. Jatene</i></p><p><br><i><strong>Instituição:</strong> Instituto do Coração do Hospital das Clínicas da Faculdade de Medicina da Universidade de São Paulo (SP)</i></p>",
                    "startTime": "14:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "9k0EGRTP67Xcz878MBZa",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ricardo Ribeiro Dias ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Tt6FYr5JIGdTBbk7EXAC",
                        "topic_name": "TL02 - Estudo prospectivo, randomizado e multicêntrico nacional para avaliar se é possível a operação da raiz da aorta e da aorta ascendente sem transfusão sanguínea e sem mortalidade",
                        "activity_location": "Auditório Principal"
                      },
                      {
                        "member_id": "vXfovm1wt1yDTbcBo0A6",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Marcello Laneza Felício ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador(a)",
                        "topic_startTime": "14:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "topic_name": "TL02 - Estudo prospectivo, randomizado e multicêntrico nacional para avaliar se é possível a operação da raiz da aorta e da aorta ascendente sem transfusão sanguínea e sem mortalidade",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Tt6FYr5JIGdTBbk7EXAC",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "WcgFv3FiPGEs1P6QzWLZ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "3º lugar • TL06 - Azul de metileno como adjuvante na primeira hora de tratamento do choque hipovolêmico: estudo experimental em porcos",
                    "text": "<p><i><strong>Autores: </strong>André<strong> </strong>Lupp Mota, Agnes Afrodite S. Albuquerque, Marelaine Prandi, Jessyca M. Barbosa, Maria Cecília Jordani, Paulo Roberto B. Evora</i></p><p><br><i><strong>Instituição: </strong>Faculdade de Medicina de Ribeirão Preto, Universidade de São Paulo (SP)</i></p>",
                    "startTime": "15:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "nreL4X3kvmJVZ6Gs05wq",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ricardo Estéfano Germano ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "WcgFv3FiPGEs1P6QzWLZ",
                        "activity_location": "Auditório Principal",
                        "topic_name": "3º lugar • TL06 - Azul de metileno como adjuvante na primeira hora de tratamento do choque hipovolêmico: estudo experimental em porcos"
                      },
                      {
                        "member_id": "5ahNmX5HyfHZqXjs0aP5",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "André Lupp Mota ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "15:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "WcgFv3FiPGEs1P6QzWLZ",
                        "activity_location": "Auditório Principal",
                        "topic_name": "3º lugar • TL06 - Azul de metileno como adjuvante na primeira hora de tratamento do choque hipovolêmico: estudo experimental em porcos"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "fROlwf8LMcRMp4rQcoBr",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TL03 -  Incidência de infecção profunda esternal após cirurgia de revascularização do miocárdio sem circulação extracorpórea e com utilização rotineira de ambas as artérias torácicas internas esqueletizadas",
                    "text": "<p><i><strong>Autores: </strong>Daniel Magalhaes, Maurilio O. Deininger, Orlando Gomes de Oliveira, John Allexander de Freitas, Eugênia di Giuseppe Deininger</i></p><p><br><i><strong>Instituição: </strong>Hospital Unimed João Pessoa - Alberto Urquiza Wanderley (PB)</i></p>",
                    "startTime": "14:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "1SPq5g5oP4AtHhClXl1m",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Daniel Marcelo Silva Magalhães ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fROlwf8LMcRMp4rQcoBr",
                        "topic_name": "TL03 -  Incidência de infecção profunda esternal após cirurgia de revascularização do miocárdio sem circulação extracorpórea e com utilização rotineira de ambas as artérias torácicas internas esqueletizadas",
                        "activity_location": "Auditório Principal"
                      },
                      {
                        "member_id": "3YKHsRROT0UV32P4W7Wm",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Paulo Manuel Pêgo-Fernandes ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "14:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "topic_name": "TL03 -  Incidência de infecção profunda esternal após cirurgia de revascularização do miocárdio sem circulação extracorpórea e com utilização rotineira de ambas as artérias torácicas internas esqueletizadas",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "fROlwf8LMcRMp4rQcoBr",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "l2DIgxaB699s5Gru9hs8",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "wvvjGWPA8BAi1AasIMRm",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "TL04 - Preservação do anel  pulmonar em correção de Tetralogia de Fallot - Experiência em um Serviço especializado",
                    "text": "<p>Autores: Ana Luiza de Oliveira Queiroz Teófilo, José Cícero Stocco Guilhen<br>Instituição: Instituto Dante Pazzanese de Cardiologia (SP)</p>",
                    "startTime": "14:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "7wgicLvlPqBQ1FxitCIm",
                        "topic_duration": "15",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Ana Luiza de Oliveira Queiroz Teófilo ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": " Apresentador(a) ",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "8ZtlIAWRw2eHpcfZW7FP",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "l2DIgxaB699s5Gru9hs8",
                        "topic_name": "TL04 - Preservação do anel  pulmonar em correção de Tetralogia de Fallot - Experiência em um Serviço especializado",
                        "activity_location": "Auditório Principal"
                      },
                      {
                        "member_id": "pwRGgdGInnHNtmVajJLN",
                        "activity_name": "SESSÃO ESPECIAL DE TEMAS LIVRES",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "14:00",
                        "member_name": "Carla Tanamati ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Comentador",
                        "topic_startTime": "14:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "QT9ZMl0B1XnPIXfMp0mx",
                        "activity_id": "wvvjGWPA8BAi1AasIMRm",
                        "topic_name": "TL04 - Preservação do anel  pulmonar em correção de Tetralogia de Fallot - Experiência em um Serviço especializado",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "l2DIgxaB699s5Gru9hs8",
                        "activity_location": "Auditório Principal"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "y11pgKFE09YDOo9Wz8BM",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 5",
                "name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                "text": "<p><strong>Dinâmica : </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p>",
                "startTime": "08:30",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "JDupwQyvnXZXKoaikvJo",
                    "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Marcos Antonio Cantero ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  },
                  {
                    "member_id": "n9Z6BDJ50t5jBtPyY8Bb",
                    "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "08:30",
                    "member_name": "Rubens Tofano de Barros ",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 5"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "16RJhUz9R6hyq8jzZ8yR",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Implante de marcapasso e CDI em crianças",
                    "text": "",
                    "startTime": "09:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "CKkNqopwpVvW55Fj6bm9",
                        "topic_duration": "15",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Wagner Tadeu Jurevicius do Nascimento",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Implante de marcapasso e CDI em crianças",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "16RJhUz9R6hyq8jzZ8yR",
                        "topic_startTime": "09:00",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "DOMeXNgxGGwQNeS0Sxaf",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Discussão",
                    "text": "",
                    "startTime": "10:00",
                    "duration": "30",
                    "agenda": []
                  },
                  {
                    "materials": [],
                    "id": "HHur5gbHF7CMo1zSSTPQ",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Extração transvenosa de cabos-eletrodos: bainhas energizadas ou convencionais?",
                    "text": "",
                    "startTime": "08:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "BmDkiUAMfzt7cHwMa3MH",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Rodrigo Minati Barbosa",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "topic_name": "Extração transvenosa de cabos-eletrodos: bainhas energizadas ou convencionais?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "HHur5gbHF7CMo1zSSTPQ"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "NQlZV36fKwrEKMdNMZwT",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Estimulação direta do sistema de condução ou marcapasso sem eletrodo?",
                    "text": "",
                    "startTime": "09:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "JQRfMjQb3Z3zbqdH03HC",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Carlos Eduardo Duarte",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "topic_name": "Estimulação direta do sistema de condução ou marcapasso sem eletrodo?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "NQlZV36fKwrEKMdNMZwT",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "Z635GQ7Fd8gToYZpfowR",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Ressincronização cardíaca ou modulação da contratilidade cardíaca?",
                    "text": "",
                    "startTime": "09:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "akUPKrpWe1E9PFpHU5Bm",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Roberto Costa ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "Ressincronização cardíaca ou modulação da contratilidade cardíaca?",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "Z635GQ7Fd8gToYZpfowR",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "hUxsY151DpcspUIX4nq2",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Infecção em DCEI: tratamento conservador ou extração?",
                    "text": "",
                    "startTime": "08:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "B1Gp5JPrjtIEP8dCrF2X",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "acceptInvite": false,
                        "level": "t",
                        "requireConfirm": false,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Tânia Mara Strabelli ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "08:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "topic_name": "Infecção em DCEI: tratamento conservador ou extração?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "hUxsY151DpcspUIX4nq2"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "yGoZqTAmhFwYPWNhTdmn",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y11pgKFE09YDOo9Wz8BM",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "Implante de CDI transvenoso ou subcutâneo?",
                    "text": "",
                    "startTime": "09:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "1aINPSVslZ6pt9f4Nwlt",
                        "activity_name": "ESTIMULAÇÃO CARDÍACA E DISPOSITIVOS ELETRÔNICOS",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "08:30",
                        "member_name": "Elizabeth Sartori Crevelari ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "09:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y11pgKFE09YDOo9Wz8BM",
                        "topic_name": "Implante de CDI transvenoso ou subcutâneo?",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "yGoZqTAmhFwYPWNhTdmn",
                        "activity_location": "Auditório 5"
                      }
                    ]
                  }
                ]
              },
              {
                "id": "y5Tki2jC5jpYmctIaG8q",
                "event_id": "qBicALVh9y4CdiTXYGrm",
                "day_id": "J6WUW98SpiJkWLybu9n5",
                "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                "location": "Auditório 4",
                "name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                "text": "<p><strong>Dinâmica: </strong>Coordenadores e palestrantes ficam no palco, na mesa diretora, durante todo o tempo. Deve haver uma recepcionista com microfone na plateia, para perguntas, caso o coordenador da Mesa abra perguntas para a plateia</p><p>Deverá estar disponível para a Mesa Diretora água em copo descartável, que deverá ser reposta pela assistente de palco na troca de atividades.</p><p><strong>Um dos coordenadores da mesa deverá ler o mini currículo do palestrante antes de iniciar sua palestra</strong>.</p>",
                "startTime": "16:45",
                "duration": null,
                "materials": [],
                "agenda": [
                  {
                    "member_id": "ErQ9Pd1VpuabuXHgLpfn",
                    "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Patricia Cristina Celestino",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  },
                  {
                    "member_id": "gAPfW2GOCBtLPWJLwYt5",
                    "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                    "requireSchedule": false,
                    "level": "a",
                    "requireConfirm": true,
                    "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "activity_startTime": "16:45",
                    "member_name": "Eduarda Cabral Braga da Costa",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_name": "Primeiro Dia",
                    "role_id": "1N7XxEx7sGOa4lVBLZQ5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "event_name": "49º Congresso da SBCCV • 2023",
                    "role_name": "Coordenador(a)",
                    "activity_location": "Auditório 4"
                  }
                ],
                "topics": [
                  {
                    "materials": [],
                    "id": "16jvOKmfpxvgLH3VyZZj",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A transição do DBLACCV para a ABRECCV",
                    "text": "",
                    "startTime": "17:30",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "p5qCiPwfNvMKW046LzEC",
                        "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Leila Nogueira Ferreira de Barros",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:30",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y5Tki2jC5jpYmctIaG8q",
                        "topic_name": "A transição do DBLACCV para a ABRECCV",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "16jvOKmfpxvgLH3VyZZj",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "9mAdgza1DdR4YD3RUvxB",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A criação do Departamento e seu impacto na vida acadêmica",
                    "text": "",
                    "startTime": "16:45",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "9L8vYBbfYLUTdMFiDQmH",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                        "requireSchedule": false,
                        "level": "t",
                        "requireConfirm": true,
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Lucas Figueredo Cardoso",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "16:45",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "topic_name": "A criação do Departamento e seu impacto na vida acadêmica",
                        "activity_id": "y5Tki2jC5jpYmctIaG8q",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "9mAdgza1DdR4YD3RUvxB",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "FhUGAeltJe5PoMsCOn3P",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "A importância do DBLACCV",
                    "text": "",
                    "startTime": "17:15",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "pHopGlaMmGboS9s4ZJPk",
                        "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                        "topic_duration": "15",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:15",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y5Tki2jC5jpYmctIaG8q",
                        "topic_name": "A importância do DBLACCV",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "FhUGAeltJe5PoMsCOn3P",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  },
                  {
                    "materials": [],
                    "id": "q0WaoFrbFX1DEibyHwzz",
                    "event_id": "qBicALVh9y4CdiTXYGrm",
                    "day_id": "J6WUW98SpiJkWLybu9n5",
                    "activity_id": "y5Tki2jC5jpYmctIaG8q",
                    "date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                    "name": "O apoio fundamental da SBCCV ",
                    "text": "",
                    "startTime": "17:00",
                    "duration": "15",
                    "agenda": [
                      {
                        "member_id": "zUJF3rGEzCCujnzfeA9P",
                        "topic_duration": "15",
                        "activity_name": "DBLACCV - MESA REDONDA II - 12 ANOS DE DBLACCV - DE VOLTA À MACEIÓ",
                        "requireSchedule": false,
                        "requireConfirm": true,
                        "level": "t",
                        "day_date": { "_seconds": 1685070000, "_nanoseconds": 0 },
                        "activity_startTime": "16:45",
                        "member_name": "Walter José Gomes ",
                        "day_id": "J6WUW98SpiJkWLybu9n5",
                        "role_name": "Palestrante",
                        "topic_startTime": "17:00",
                        "event_id": "qBicALVh9y4CdiTXYGrm",
                        "day_name": "Primeiro Dia",
                        "role_id": "BcYHERVzWLzxVYs443Xn",
                        "activity_id": "y5Tki2jC5jpYmctIaG8q",
                        "topic_name": "O apoio fundamental da SBCCV ",
                        "event_name": "49º Congresso da SBCCV • 2023",
                        "topic_id": "q0WaoFrbFX1DEibyHwzz",
                        "activity_location": "Auditório 4"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

